
import { useState, useEffect, useCallback } from "react";
import {
  Checkbox, Box, Button, Paper, Dialog, DialogActions, DialogContent, DialogTitle, Snackbar, Alert, CircularProgress, TextField, FormLabel, RadioGroup, FormControlLabel, Radio, Typography,
  CardContent, Chip, Toolbar, IconButton, Tooltip, Badge, useTheme, alpha, List, ListItem, ListItemAvatar, ListItemText, Divider
} from '@mui/material';
import AddIcon from '@mui/icons-material/Add';
import RemoveIcon from '@mui/icons-material/Remove';


import {
  Schedule as ScheduleIcon,
  Person as PersonIcon,
  Warning as WarningIcon,
  CheckCircle as CheckCircleIcon,
  Factory as FactoryIcon,
  People as PeopleIcon,
  Delete as DeleteIcon,
  Group as GroupIcon,
  Check as CheckIcon,
  Cancel as CancelIcon,
  Inventory as InventoryIcon,
  DeleteOutline as WasteIcon,
  Notes as NotesIcon,
  WorkOff as WorkOffIcon,
  AccessTime as TimeIcon
} from '@mui/icons-material';


import InfoIcon from '@mui/icons-material/Info';
import RestaurantIcon from '@mui/icons-material/Restaurant';
import PauseIcon from '@mui/icons-material/Pause';
import SearchOffIcon from '@mui/icons-material/SearchOff';


import Avatar from '@mui/material/Avatar';
import StopIcon from '@mui/icons-material/Stop';
import PlayArrowIcon from '@mui/icons-material/PlayArrow';
import AccessTimeIcon from '@mui/icons-material/AccessTime';
import CloseIcon from '@mui/icons-material/Close';

import axios from "axios";
import TaskAltIcon from '@mui/icons-material/TaskAlt';
import PauseCircleOutlineIcon from '@mui/icons-material/PauseCircleOutline';
import HourglassTopIcon from '@mui/icons-material/HourglassTop';
import PersonRemoveIcon from '@mui/icons-material/PersonRemove';
import WorkIcon from '@mui/icons-material/Work';
import GroupsIcon from '@mui/icons-material/Groups';

import AssignmentIcon from '@mui/icons-material/Assignment';

import ShiftAddButton from "./ShiftAddButton";
import JobAddButton from "./JobAddButton";
import PropTypes from 'prop-types';


const API_BASE_URL = process.env.REACT_APP_API_BASE_URL;


const SupervisorEnterDashbord = ({ supervisorId, machineCode, Groupcode, finishedGood,refreshKey = 0, onTriggerSnackbar }) => {
  const theme = useTheme();


  const [bulkEmployeeList, setBulkEmployeeList] = useState([]);
  const [checkboxMode, setCheckboxMode] = useState(null); // 'idle', 'ongoing', 'mixed'



  const [selectedEmployees, setSelectedEmployees] = useState(new Set());
  const [bulkActionType, setBulkActionType] = useState('');
  const [bulkActionDialogOpen, setBulkActionDialogOpen] = useState(false);

  const [open, setOpen] = useState(false);
  const [employeeList, setEmployeeList] = useState([]);
  const [isSecondModalOpen, setIsSecondModalOpen] = useState(false);
  const [idleTimesData, setIdleTimesData] = useState([]);
  const [currentEmployee, setCurrentEmployee] = useState(null);
  const [selectedJob, setSelectedJob] = useState(null);
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [isOngoingModalOpen, setIsOngoingModalOpen] = useState(false);

  const [confirmRemoveOpen, setConfirmRemoveOpen] = useState(false);
  const [employeeToRemove, setEmployeeToRemove] = useState(null);

  const [snackbarOpen, setSnackbarOpen] = useState(false);
  const [snackbarMessage, setSnackbarMessage] = useState('');
  const [snackbarSeverity, setSnackbarSeverity] = useState('info');
  const [assignedEmployees, setAssignedEmployees] = useState([]);

  const [productionConfirmOpen, setProductionConfirmOpen] = useState(false);
  const [currentProductionEmployee, setCurrentProductionEmployee] = useState(null);

  const [openIdleCodesDialog, setOpenIdleCodesDialog] = useState(false);
  const [idleCodesData, setIdleCodesData] = useState([]);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);
  const [confirmjobIdleStartOpen, setConfirmjobIdleStartOpen] = useState(false);
  const [selectedCodeItem, setSelectedCodeItem] = useState(null);
  const [confirmEndOpen, setConfirmEndOpen] = useState(false);
  const [currentEndAction, setCurrentEndAction] = useState(null);
  const [currentEndEmployee, setCurrentEndEmployee] = useState(null);

  const [endJobConfirmOpen, setEndJobConfirmOpen] = useState(false);
  const [jobCloseDialogOpen, setJobCloseDialogOpen] = useState(false);
  const [productionQty, setProductionQty] = useState('');
  const [wasteQty, setWasteQty] = useState('');
  const [remarks, setRemarks] = useState('');
  const [selectedEmployee, setSelectedEmployee] = useState(null);

  const [productionQtyError, setProductionQtyError] = useState(false);
  const [wasteQtyError, setWasteQtyError] = useState(false);

  const [manhourNoOperationData, setManhourNoOperationData] = useState([]);
  const [manhourIdleNonJobData, setManhourIdleNonJobData] = useState([]);
  const [manhourJobStartedNoOperationData, setManhourJobStartedNoOperationData] = useState([]);
  const [manhourJobAndOperationOngoingData, setManhourJobAndOperationOngoingData] = useState([]);

  const [finishGoodSelection, setFinishGoodSelection] = useState("no");
  const [jobStatus, setJobStatus] = useState("incomplete");

  const [selectedJobEmployees, setSelectedJobEmployees] = useState(new Set());
  const [jobCheckboxMode, setJobCheckboxMode] = useState(null);
  const [bulkJobEmployeeList, setBulkJobEmployeeList] = useState([]);

  const [packingDetails, setPackingDetails] = useState([{ id: 1, boxes: '', cartonsPerBox: '', total: 0 }]);
  const [packingDetailsError, setPackingDetailsError] = useState(false);

  const apiBaseUrl = `${API_BASE_URL}`;


  const handleAddPackingRow = () => {
    const newId = packingDetails.length > 0 ? Math.max(...packingDetails.map(p => p.id)) + 1 : 1;
    setPackingDetails([...packingDetails, { id: newId, boxes: '', cartonsPerBox: '', total: 0 }]);
  };

  const handleRemovePackingRow = (id) => {
    if (packingDetails.length > 1) {
      setPackingDetails(packingDetails.filter(row => row.id !== id));
    }
  };

  const handlePackingChange = (id, field, value) => {
    // Only allow numbers
    const numericValue = value.replace(/\D/g, '');

    setPackingDetails(packingDetails.map(row => {
      if (row.id === id) {
        const updatedRow = { ...row, [field]: numericValue };

        // Calculate total
        const boxes = field === 'boxes' ? parseFloat(numericValue) || 0 : parseFloat(row.boxes) || 0;
        const cartonsPerBox = field === 'cartonsPerBox' ? parseFloat(numericValue) || 0 : parseFloat(row.cartonsPerBox) || 0;
        updatedRow.total = boxes * cartonsPerBox;

        return updatedRow;
      }
      return row;
    }));
  };

  const formatPackingNumber = (value) => {
    if (!value) return '';
    return new Intl.NumberFormat('en-US').format(value);
  };

  const getTotalCartons = () => {
    return packingDetails.reduce((sum, row) => sum + (row.total || 0), 0);
  };


  const toggleJobEmployeeSelection = (empId) => {
    const employee = assignedEmployees.find(e => e.emp_id === empId);
    let currentMode = 'available'; // default for employees with no ongoing operations

    if (employee?.isProductionStarted) {
      currentMode = 'production';
    } else if (employee?.isIdleStarted) {
      currentMode = 'idle';
    }

    setSelectedJobEmployees(prev => {
      const newSet = new Set(prev);

      if (newSet.has(empId)) {
        newSet.delete(empId);
      } else {
        // First selection sets the mode
        if (newSet.size === 0) {
          setJobCheckboxMode(currentMode);
          newSet.add(empId);
        } else {
          // Check if new selection matches current mode
          if (jobCheckboxMode === currentMode) {
            newSet.add(empId);
          } else {
            setSnackbarMessage(`You can only select employees with the same status (${jobCheckboxMode}).`);
            setSnackbarSeverity("warning");
            setSnackbarOpen(true);
          }
        }
      }

      if (newSet.size === 0) {
        setJobCheckboxMode(null);
      }

      return newSet;
    });
  };


  const handleBulkJobAction = (actionType) => {
    if (selectedJobEmployees.size === 0) {
      setSnackbarMessage("Please select at least one employee");
      setSnackbarSeverity("warning");
      setSnackbarOpen(true);
      return;
    }

    const selectedEmployeeData = assignedEmployees.filter(emp =>
      selectedJobEmployees.has(emp.emp_id)
    );

    if (actionType === 'idle') {
      setBulkJobEmployeeList(selectedEmployeeData);
      setCurrentEmployee(selectedEmployeeData[0]); // Set for dialog context
      fetchIdleCodes(); // Will open the idle code dialog
    } else if (actionType === 'production') {
      // FIXED: Don't set bulkJobEmployeeList, directly call the function with data
      handleBulkProductionStart(selectedEmployeeData);
    } else if (actionType === 'endProduction') {
      handleBulkProductionEnd(selectedEmployeeData);
    } else if (actionType === 'endIdle') {
      handleBulkJobIdleEnd(selectedEmployeeData);
    }
  };



  const handleBulkProductionStart = async (selectedEmployeeData = null) => {
    // Use passed data or fallback to bulkJobEmployeeList
    const employeesToProcess = selectedEmployeeData || bulkJobEmployeeList;

    if (!employeesToProcess || employeesToProcess.length === 0) {
      setSnackbarMessage("No employees selected for production start");
      setSnackbarSeverity("warning");
      setSnackbarOpen(true);
      return;
    }

    let successCount = 0;
    let errorCount = 0;

    for (const employee of employeesToProcess) {
      const dataToSend = {
        supervisor_id: supervisorId,
        emp_id: employee.emp_id,
        emp_name: employee.emp_name,
        station_code: machineCode,
        job_number: employee.job.jobNumber,
        customer: employee.job.customer,
        product: employee.job.product,
        main_operation: employee.job.mainoperation,
        operation_description: "production",
        operation_type: "production",
        operation_code: "PROD",
        start_datetime: new Date().toISOString(),
        active_status: "ongoing",
        job_started_time: employee.job.job_started_time
      };

      try {
        const response = await axios.post(`${API_BASE_URL}/manhourprodstart`, dataToSend);
        if (response.status === 200) {
          const insertedData = response.data.inserted_data;
          setAssignedEmployees((prevAssigned) =>
            prevAssigned.map((emp) =>
              emp.emp_id === insertedData.emp_id
                ? {
                  ...emp,
                  production_start_datetime: insertedData.start_datetime,
                  isProductionStarted: true,
                }
                : emp
            )
          );
          successCount++;
        }
      } catch (error) {
        console.error(`Error starting production for ${employee.emp_name}`, error);
        errorCount++;
      }
    }

    // Clear selections
    setSelectedJobEmployees(new Set());
    setJobCheckboxMode(null);
    setBulkJobEmployeeList([]);

    // Show appropriate message
    if (successCount > 0 && errorCount === 0) {
      setSnackbarMessage(`Production started successfully for ${successCount} employee(s).`);
      setSnackbarSeverity("success");
    } else if (successCount > 0 && errorCount > 0) {
      setSnackbarMessage(`Production started for ${successCount} employee(s). ${errorCount} failed.`);
      setSnackbarSeverity("warning");
    } else {
      setSnackbarMessage("Failed to start production for selected employees.");
      setSnackbarSeverity("error");
    }
    setSnackbarOpen(true);
  };



  const handleBulkJobIdleStart = async () => {
    if (!bulkJobEmployeeList || bulkJobEmployeeList.length === 0) {
      setSnackbarMessage("No employees selected for idle start");
      setSnackbarSeverity("warning");
      setSnackbarOpen(true);
      return;
    }

    const operationType = ["IT-DT", "IT-LT", "IT-TT"].includes(selectedCodeItem.code)
      ? "Meals"
      : "Idle";

    let successCount = 0;
    let errorCount = 0;

    for (const employee of bulkJobEmployeeList) {
      const dataToSend = {
        supervisor_id: supervisorId,
        emp_id: employee.emp_id,
        emp_name: employee.emp_name,
        station_code: machineCode,
        job_number: employee.job.jobNumber,
        customer: employee.job.customer,
        product: employee.job.product,
        main_operation: employee.job.mainoperation,
        operation_code: selectedCodeItem.code,
        operation_description: selectedCodeItem.process,
        operation_type: operationType,
        start_datetime: new Date().toISOString(),
        job_started_time: employee.job.job_started_time,
        active_status: "ongoing"
      };

      try {
        const response = await axios.post(`${API_BASE_URL}/manhourJobIdleStart`, dataToSend);
        if (response.status === 200) {
          const insertedData = response.data.inserted_data;
          setAssignedEmployees((prevAssigned) =>
            prevAssigned.map((emp) =>
              emp.emp_id === insertedData.emp_id
                ? {
                  ...emp,
                  idle_start_datetime: insertedData.start_datetime,
                  isIdleStarted: true,
                  ongoingJobIdleCode: insertedData.operation_code,
                }
                : emp
            )
          );
          successCount++;
        }
      } catch (error) {
        console.error(`Error starting idle for ${employee.emp_name}`, error);
        errorCount++;
      }
    }

    // Clear selections
    setSelectedJobEmployees(new Set());
    setJobCheckboxMode(null);
    setBulkJobEmployeeList([]);
    setConfirmjobIdleStartOpen(false);
    setOpenIdleCodesDialog(false);

    // Show appropriate message
    if (successCount > 0 && errorCount === 0) {
      setSnackbarMessage(`Idle operation started successfully for ${successCount} employee(s).`);
      setSnackbarSeverity("success");
    } else if (successCount > 0 && errorCount > 0) {
      setSnackbarMessage(`Idle started for ${successCount} employee(s). ${errorCount} failed.`);
      setSnackbarSeverity("warning");
    } else {
      setSnackbarMessage("Failed to start idle operation for selected employees.");
      setSnackbarSeverity("error");
    }
    setSnackbarOpen(true);
  };


  const handleBulkProductionEnd = async (selectedEmployeeData) => {
    let successCount = 0;
    let errorCount = 0;

    for (const employee of selectedEmployeeData) {
      const dataToSend = {
        supervisor_id: supervisorId,
        emp_id: employee.emp_id,
        station_code: machineCode,
        start_datetime: employee.production_start_datetime,
        job_started_time: employee.job?.job_started_time,
        end_datetime: new Date().toISOString(),
      };

      try {
        const response = await axios.post(`${API_BASE_URL}/manhourprodEnd`, dataToSend);
        if (response.status === 200) {
          setAssignedEmployees((prevAssigned) =>
            prevAssigned.map((assignedEmployee) =>
              assignedEmployee.emp_id === employee.emp_id
                ? {
                  ...assignedEmployee,
                  production_start_datetime: null,
                  isProductionStarted: false,
                }
                : assignedEmployee
            )
          );
          successCount++;
        }
      } catch (error) {
        console.error(`Error ending production for ${employee.emp_name}`, error);
        errorCount++;
      }
    }

    setSelectedJobEmployees(new Set());
    setJobCheckboxMode(null);

    // Show appropriate message
    if (successCount > 0 && errorCount === 0) {
      setSnackbarMessage(`Production ended successfully for ${successCount} employee(s).`);
      setSnackbarSeverity("success");
    } else if (successCount > 0 && errorCount > 0) {
      setSnackbarMessage(`Production ended for ${successCount} employee(s). ${errorCount} failed.`);
      setSnackbarSeverity("warning");
    } else {
      setSnackbarMessage("Failed to end production for selected employees.");
      setSnackbarSeverity("error");
    }
    setSnackbarOpen(true);
  };




  const handleBulkJobIdleEnd = async (selectedEmployeeData) => {
    let successCount = 0;
    let errorCount = 0;

    for (const employee of selectedEmployeeData) {
      const dataToSend = {
        supervisor_id: supervisorId,
        emp_id: employee.emp_id,
        station_code: machineCode,
        operation_code: employee.ongoingJobIdleCode,
        start_datetime: employee.idle_start_datetime,
        job_started_time: employee.job.job_started_time,
        end_datetime: new Date().toISOString(),
        active_status: "ended",
      };

      try {
        const response = await axios.post(`${API_BASE_URL}/manhourjobidleend`, dataToSend);
        if (response.status === 200) {
          setAssignedEmployees((prevAssigned) =>
            prevAssigned.map((assignedEmployee) =>
              assignedEmployee.emp_id === employee.emp_id
                ? {
                  ...assignedEmployee,
                  idle_start_datetime: null,
                  isIdleStarted: false,
                  ongoingJobIdleCode: null,
                }
                : assignedEmployee
            )
          );
          successCount++;
        }
      } catch (error) {
        console.error(`Error ending idle for ${employee.emp_name}`, error);
        errorCount++;
      }
    }

    setSelectedJobEmployees(new Set());
    setJobCheckboxMode(null);

    // Show appropriate message
    if (successCount > 0 && errorCount === 0) {
      setSnackbarMessage(`Idle operation ended successfully for ${successCount} employee(s).`);
      setSnackbarSeverity("success");
    } else if (successCount > 0 && errorCount > 0) {
      setSnackbarMessage(`Idle ended for ${successCount} employee(s). ${errorCount} failed.`);
      setSnackbarSeverity("warning");
    } else {
      setSnackbarMessage("Failed to end idle operation for selected employees.");
      setSnackbarSeverity("error");
    }
    setSnackbarOpen(true);
  };




  const handleConfirmJobIdleStart = async () => {
    if (bulkJobEmployeeList.length > 0) {
      // Handle bulk idle start
      await handleBulkJobIdleStart();
    } else {
      // Handle single employee idle start (existing logic)
      const operationType = ["IT-DT", "IT-LT", "IT-TT"].includes(selectedCodeItem.code)
        ? "Meals"
        : "Idle";

      const dataToSend = {
        supervisor_id: supervisorId,
        emp_id: currentEmployee?.emp_id,
        emp_name: currentEmployee?.emp_name,
        station_code: machineCode,
        job_number: currentEmployee.job.jobNumber,
        customer: currentEmployee.job.customer,
        product: currentEmployee.job.product,
        main_operation: currentEmployee.job.mainoperation,
        operation_code: selectedCodeItem.code,
        operation_description: selectedCodeItem.process,
        operation_type: operationType,
        start_datetime: new Date().toISOString(),
        job_started_time: currentEmployee.job.job_started_time,
        active_status: "ongoing"
      };

      try {
        const response = await axios.post(`${API_BASE_URL}/manhourJobIdleStart`, dataToSend);

        if (response.status === 200) {
          const insertedData = response.data.inserted_data;
          setAssignedEmployees((prevAssigned) =>
            prevAssigned.map((employee) =>
              employee.emp_id === insertedData.emp_id
                ? {
                  ...employee,
                  idle_start_datetime: insertedData.start_datetime,
                  isIdleStarted: true,
                  ongoingJobIdleCode: insertedData.operation_code,
                }
                : employee
            )
          );


          // 🔧 ADD THIS: Reset job selection state after individual idle assignment
          setSelectedJobEmployees((prevSelected) => {
            const newSelected = new Set(prevSelected);
            newSelected.delete(currentEmployee?.emp_id);

            // If this was the last selected employee, reset checkbox mode
            if (newSelected.size === 0) {
              setJobCheckboxMode(null);
            }

            return newSelected;
          });
          setSnackbarMessage("Idle operation started successfully.");
          setSnackbarSeverity("success");
        }
      } catch (error) {
        console.error("Error starting idle operation:", error);
        setSnackbarMessage("Failed to start idle operation.");
        setSnackbarSeverity("error");
      } finally {
        setSnackbarOpen(true);
        setConfirmjobIdleStartOpen(false);
        setOpenIdleCodesDialog(false);
      }
    }
  };


  const toggleEmployeeSelection = (empId) => {
    const employee = employeeList.find(e => e.empId === empId);
    const isOngoing = !!employee?.startedAt;

    setSelectedEmployees(prev => {
      const newSet = new Set(prev);

      if (newSet.has(empId)) {
        newSet.delete(empId);
      } else {
        // First selection sets the mode
        if (newSet.size === 0) {
          setCheckboxMode(isOngoing ? 'ongoing' : 'idle');
          newSet.add(empId);
        } else {
          const sampleId = Array.from(newSet)[0];
          const sampleEmp = employeeList.find(e => e.empId === sampleId);
          const sampleIsOngoing = !!sampleEmp?.startedAt;

          if (sampleIsOngoing === isOngoing) {
            newSet.add(empId);
          } else {
            setSnackbarMessage("You can only select employees with the same status.");
            setSnackbarSeverity("warning");
            setSnackbarOpen(true);
          }
        }
      }

      if (newSet.size === 0) {
        setCheckboxMode(null);
      }

      return newSet;
    });
  };


  const handleBulkOngoingEnd = async () => {
    for (const empId of selectedEmployees) {
      const employee = employeeList.find(e => e.empId === empId);

      if (!employee?.startedAt) continue;

      const dataToSend = {
        supervisor_id: supervisorId,
        emp_id: employee.empId,
        station_code: machineCode,
        operation_code: employee.ongoingProcessCode,
        start_datetime: employee.startedAt,
        end_datetime: new Date().toISOString(),
        active_status: "ended",
      };

      try {
        await axios.post(`${API_BASE_URL}/manhouridleend`, dataToSend);
        setEmployeeList(prev =>
          prev.map(emp =>
            emp.empId === empId
              ? { ...emp, startedAt: null, ongoingProcessCode: null }
              : emp
          )
        );
      } catch (error) {
        console.error(`Failed to end process for ${employee.empName}`, error);
      }
    }

    setSnackbarMessage("Ongoing processes ended.");
    setSnackbarSeverity("success");
    setSnackbarOpen(true);
    setSelectedEmployees(new Set());
    setCheckboxMode(null);


  };


  const handleBulkAction = (actionType) => {
    if (selectedEmployees.size === 0) {
      setSnackbarMessage("Please select at least one employee");
      setSnackbarSeverity("warning");
      setSnackbarOpen(true);
      return;
    }

    if (actionType === 'idle') {
      const selectedEmployeeData = employeeList.filter(emp =>
        selectedEmployees.has(emp.empId)
      );
      setBulkEmployeeList(selectedEmployeeData);
      fetchIdleTimes(); // Will open the idle code dialog
    } else if (actionType === 'remove') {
      setBulkActionType(actionType);
      setBulkActionDialogOpen(true);
    }
  };

  const confirmBulkAction = () => {
    const selectedEmployeeData = employeeList.filter(emp =>
      selectedEmployees.has(emp.empId)
    );

    if (bulkActionType === 'idle') {
      // Handle bulk idle time assignment
      // You'll need to modify your idle time dialog to handle multiple employees
    } else if (bulkActionType === 'remove') {
      // Handle bulk removal
      selectedEmployeeData.forEach(emp => {
        if (!emp.startedAt) {
          handleRemoveFromWorkstation(emp.empId);
        }
      });
    }

    setBulkActionDialogOpen(false);
    setSelectedEmployees(new Set());
    setCheckboxMode(null);
  };

  const fetchData = useCallback(async (endpoint, setData, errorMsg) => {
    console.log(`Fetching data from endpoint: ${endpoint}`);
    setLoading(true);
    try {
      const params = { station_code: machineCode, supervisor_id: supervisorId };
      console.log(`Sending request with params:`, params);
      const response = await axios.get(`${apiBaseUrl}/${endpoint}`, { params });
      console.log(`Response received from ${endpoint}:`, response.data);
      setData(response.data);
    } catch (error) {
      console.error(errorMsg, error);
      setSnackbarMessage(errorMsg);
      setSnackbarSeverity("error");
      setSnackbarOpen(true);
    } finally {
      setLoading(false);
    }
  }, [machineCode, supervisorId, apiBaseUrl]);

  useEffect(() => {
    console.log("Fetching initial data for No Operation and Idle Non-Job endpoints.");
    fetchData("manhourRefresh/noOperation", setManhourNoOperationData, "Failed to fetch data for No Operation");
    fetchData("manhourRefresh/idleNonJob", setManhourIdleNonJobData, "Failed to fetch data for Idle Non-Job");
  }, [supervisorId, machineCode, refreshKey,fetchData]);

  useEffect(() => {
    console.log("manhourNoOperationData updated:", manhourNoOperationData);
    console.log("manhourIdleNonJobData updated:", manhourIdleNonJobData);
    updateEmployeeList(manhourNoOperationData, manhourIdleNonJobData);
  }, [manhourNoOperationData, manhourIdleNonJobData]);

  useEffect(() => {
    console.log("Fetching data for Job Started No Operation and Job And Operation Ongoing endpoints.");
    fetchData("manhourRefresh/jobStartedNoOperation", setManhourJobStartedNoOperationData, "Failed to fetch data for Job Started No Operation");
    fetchData("manhourRefresh/jobAndOperationOngoing", setManhourJobAndOperationOngoingData, "Failed to fetch data for Job and Operation Ongoing");
  }, [supervisorId, machineCode,refreshKey, fetchData]);

  useEffect(() => {
    console.log("manhourJobStartedNoOperationData updated:", manhourJobStartedNoOperationData);
    console.log("manhourJobAndOperationOngoingData updated:", manhourJobAndOperationOngoingData);
    updateAssignedEmployees(manhourJobStartedNoOperationData, manhourJobAndOperationOngoingData);
  }, [manhourJobStartedNoOperationData, manhourJobAndOperationOngoingData]);

  const updateEmployeeList = (noOperationData, idleNonJobData) => {
    if (!Array.isArray(noOperationData)) {
      console.error("Expected noOperationData to be an array, got:", noOperationData);
      noOperationData = [];
    }

    if (!Array.isArray(idleNonJobData)) {
      console.error("Expected idleNonJobData to be an array, got:", idleNonJobData);
      idleNonJobData = [];
    }

    const updatedList = noOperationData.map((employee) => ({
      empId: employee.emp_id,
      empName: employee.emp_name
    }));

    idleNonJobData.forEach((idleEmployee) => {
      const existingEmployeeIndex = updatedList.findIndex(
        (emp) => emp.empId === idleEmployee.emp_id
      );

      if (existingEmployeeIndex > -1) {
        updatedList[existingEmployeeIndex] = {
          ...updatedList[existingEmployeeIndex],
          startedAt: idleEmployee.start_datetime,
          ongoingProcessCode: idleEmployee.operation_code
        };
      } else {
        updatedList.push({
          empId: idleEmployee.emp_id,
          empName: idleEmployee.emp_name,
          startedAt: idleEmployee.start_datetime,
          ongoingProcessCode: idleEmployee.operation_code
        });
      }
    });

    console.log("Updated employee list:", updatedList);
    setEmployeeList(updatedList);
  };

  const updateAssignedEmployees = (jobStartedData, ongoingData) => {
    console.log("Updating assigned employees with Job Started and Ongoing data.");
    const updatedAssignedEmployees = jobStartedData.map((employee) => ({
      emp_id: employee.emp_id,
      emp_name: employee.emp_name,
      job: {
        jobNumber: employee.job_number,
        customer: employee.customer,
        product: employee.product,
        mainoperation: employee.main_operation,
        upCount: employee.up_count,
        job_started_time: employee.job_started_time
      }
    }));

    ongoingData.forEach((ongoingEmployee) => {
      const existingEmployeeIndex = updatedAssignedEmployees.findIndex(
        (emp) => emp.emp_id === ongoingEmployee.emp_id
      );

      const updatedEmployeeData = {
        emp_id: ongoingEmployee.emp_id,
        emp_name: ongoingEmployee.emp_name,
        job: {
          jobNumber: ongoingEmployee.job_number,
          customer: ongoingEmployee.customer,
          product: ongoingEmployee.product,
          mainoperation: ongoingEmployee.main_operation,
          upCount: ongoingEmployee.up_count,
          job_started_time: ongoingEmployee.job_started_time
        },
        ongoingJobIdleCode: ongoingEmployee.operation_code,
        operation_description: ongoingEmployee.operation_description,
      };

      if (ongoingEmployee.operation_code.startsWith("PROD")) {
        updatedEmployeeData.isProductionStarted = true;
        updatedEmployeeData.production_start_datetime = ongoingEmployee.start_datetime;
      } else if (ongoingEmployee.operation_code.startsWith("IT")) {
        updatedEmployeeData.isIdleStarted = true;
        updatedEmployeeData.idle_start_datetime = ongoingEmployee.start_datetime;
      }

      if (existingEmployeeIndex > -1) {
        updatedAssignedEmployees[existingEmployeeIndex] = {
          ...updatedAssignedEmployees[existingEmployeeIndex],
          ...updatedEmployeeData
        };
      } else {
        updatedAssignedEmployees.push(updatedEmployeeData);
      }
    });
    console.log("Updated assignedEmployees:", updatedAssignedEmployees);
    setAssignedEmployees(updatedAssignedEmployees);
  };

  const handleEndJob = (endedJobData) => {
    if (!endedJobData) {
      console.error('No job end data received from backend');
      return;
    }

    console.log('Job Ended for:', endedJobData);

    setAssignedEmployees((prevAssigned) =>
      prevAssigned.filter(
        (assignedEmployee) => assignedEmployee.emp_id !== endedJobData.emp_id
      )
    );

    setEmployeeList((prevList) => [
      ...prevList,
      {
        empId: endedJobData.emp_id,
        empName: endedJobData.emp_name,
        job: null,
      }
    ]);
  };

  const formatNumber = (value) => {
    if (!value) return '';
    const numericValue = value.replace(/,/g, '');
    return new Intl.NumberFormat('en-US').format(numericValue);
  }

  const handleProductionQtyChange = (e) => {
    const value = e.target.value.replace(/\D/g, '');
    setProductionQty(formatNumber(value));
  };

  const handleWasteQtyChange = (e) => {
    const value = e.target.value.replace(/\D/g, '');
    setWasteQty(formatNumber(value));
  };

  const handleEndJobClick = (employee) => {
    setSelectedEmployee(employee);
    setEndJobConfirmOpen(true);
    console.log("end job employee", employee);
  };

  const handleEndJobConfirmClose = () => {
    setEndJobConfirmOpen(false);
  };

  const handleConfirmEndJob = () => {
    setEndJobConfirmOpen(false);
    setJobCloseDialogOpen(true);
  };

  const handleJobCloseDialogClose = () => {
    setJobCloseDialogOpen(false);
    setProductionQty('');
    setWasteQty('');
    setRemarks('');
    setPackingDetails([{ id: 1, boxes: '', cartonsPerBox: '', total: 0 }]); // Add this line
    setPackingDetailsError(false);
  };


  const handleConfirmEndJobClose = () => {
    setProductionQtyError(false);
    setWasteQtyError(false);
    setPackingDetailsError(false);

    let hasError = false;
    if (!productionQty) {
      setProductionQtyError(true);
      hasError = true;
    }
    if (!wasteQty) {
      setWasteQtyError(true);
      hasError = true;
    }

    // Validate packing details if finish good is yes
    if (finishGoodSelection === 'yes') {
      const hasIncompletePacking = packingDetails.some(row => !row.boxes || !row.cartonsPerBox);
      if (hasIncompletePacking) {
        setPackingDetailsError(true);
        hasError = true;
        setSnackbarMessage("Please complete all packing details or remove empty rows.");
        setSnackbarSeverity("error");
        setSnackbarOpen(true);
      }
    }

    if (hasError) {
      return;
    }

    const dataToSend = {
      supervisor_id: supervisorId,
      emp_id: selectedEmployee.emp_id,
      emp_name: selectedEmployee.emp_name,
      job_number: selectedEmployee.job?.jobNumber,
      customer: selectedEmployee.job?.customer,
      product: selectedEmployee.job?.product,
      main_operation: selectedEmployee.job?.mainoperation,
      station_code: machineCode,
      finishGood: finishGoodSelection,
      jobStatus: jobStatus,
      production_qty: productionQty.replace(/,/g, ''),
      waste_qty: wasteQty.replace(/,/g, ''),
      remarks,
      end_datetime: new Date().toISOString(),
      job_started_time: selectedEmployee.job?.job_started_time,
      // Add packing details if finish good is yes
      ...(finishGoodSelection === 'yes' && {
        packingDetails: packingDetails.map(row => ({
          boxes: parseInt(row.boxes),
          cartonsPerBox: parseInt(row.cartonsPerBox),
          total: row.total
        })),
        totalCartons: getTotalCartons()
      })
    };

    console.log("Sending data to /manhourjobend:", dataToSend);

    axios.post(`${API_BASE_URL}/manhourjobend`, dataToSend)
      .then((response) => {
        if (response.status === 200) {
          console.log("Job ended successfully:", response.data);

          setSelectedJobEmployees((prevSelected) => {
            const newSelected = new Set(prevSelected);
            newSelected.delete(selectedEmployee.emp_id);

            if (newSelected.size === 0) {
              setJobCheckboxMode(null);
            }

            return newSelected;
          });

          setSnackbarMessage("Job ended successfully.");
          setSnackbarSeverity("success");
          setSnackbarOpen(true);
          handleEndJob(response.data.updated_data);
        }
      })
      .catch((error) => {
        console.error("Error ending job:", error);
        setSnackbarMessage("Error ending job.");
        setSnackbarSeverity("error");
        setSnackbarOpen(true);
      })
      .finally(() => {
        setJobCloseDialogOpen(false);
        setProductionQty('');
        setWasteQty('');
        setRemarks('');
        setPackingDetails([{ id: 1, boxes: '', cartonsPerBox: '', total: 0 }]);
        setPackingDetailsError(false);
      });
  };



  const handleOpenEndConfirmDialog = (employee, action) => {
    setCurrentEndEmployee(employee);
    setCurrentEndAction(action);
    setConfirmEndOpen(true);
  };

  const handleCloseEndConfirmDialog = () => {
    setConfirmEndOpen(false);
    setCurrentEndAction(null);
    setCurrentEndEmployee(null);
  };

  const handleConfirmEndAction = () => {
    if (currentEndAction === 'production') {
      handleProductionEndConfirm(currentEndEmployee);
    } else if (currentEndAction === 'idle') {
      handleJobIdleEndClick(currentEndEmployee);
    }
    handleCloseEndConfirmDialog();
  };

  const handleJobIdleCodeClick = (codeItem) => {
    setSelectedCodeItem(codeItem);
    setConfirmjobIdleStartOpen(true);
  };

  const handleClickJobIdleOpen = (employee) => {
    setCurrentEmployee(employee);
    fetchIdleCodes();
    setLoading(true);
    setError(null);
    console.log("jobIdleEmployee", employee)
  }



  useEffect(() => {
    console.log("Updated employee data:", assignedEmployees);
  }, [assignedEmployees]);

  const fetchIdleCodes = () => {
    axios
      .get(`${API_BASE_URL}/idlecodesbygroupcode/${Groupcode}`)
      .then((response) => {
        setIdleCodesData(response.data);
        setOpenIdleCodesDialog(true);
      })
      .catch((err) => {
        console.error("Error fetching idle codes:", err);
        setError("Failed to fetch idle codes.");
      })
      .finally(() => setLoading(false));
  };

  const handleCloseIdleCodesDialog = () => {
    setOpenIdleCodesDialog(false);
    setIdleCodesData([]);
  };

  const handleJobIdleEndClick = async (employee) => {
    const endDatetime = new Date().toISOString();
    console.log("Idle end click", employee);

    const dataToSend = {
      supervisor_id: supervisorId,
      emp_id: employee.emp_id,
      station_code: machineCode,
      operation_code: employee.ongoingJobIdleCode,
      start_datetime: employee.idle_start_datetime,
      job_started_time: employee.job.job_started_time,
      end_datetime: endDatetime,
      active_status: "ended",
    };

    try {
      const response = await axios.post(`${API_BASE_URL}/manhourjobidleend`, dataToSend);

      if (response.status === 200) {
        console.log("Idle operation ended successfully:", response.data);

        setAssignedEmployees((prevAssigned) =>
          prevAssigned.map((assignedEmployee) =>
            assignedEmployee.emp_id === employee.emp_id
              ? {
                ...assignedEmployee,
                idle_start_datetime: null,
                isIdleStarted: false,
                ongoingJobIdleCode: null,
              }
              : assignedEmployee
          )
        );

        setSnackbarMessage("Idle operation ended successfully.");
        setSnackbarSeverity("success");
      }
    } catch (error) {
      console.error("Error ending idle operation:", error);
      setSnackbarMessage("Failed to end idle operation.");
      setSnackbarSeverity("error");
    } finally {
      setSnackbarOpen(true);
    }
  };

  const handleProductionEndConfirm = async (employee) => {
    if (!employee) {
      console.error('No employee selected for production end');
      return;
    }

    const dataToSend = {
      supervisor_id: supervisorId,
      emp_id: employee.emp_id,
      station_code: machineCode,
      start_datetime: employee.production_start_datetime,
      job_started_time: employee.job?.job_started_time,
      end_datetime: new Date().toISOString(),
    };

    console.log("Data to send for ending production:", dataToSend);

    try {
      const response = await axios.post(`${API_BASE_URL}/manhourprodEnd`, dataToSend);

      if (response.status === 200) {
        console.log("Production ended data", response.data);

        setAssignedEmployees((prevAssigned) =>
          prevAssigned.map((assignedEmployee) =>
            assignedEmployee.emp_id === employee.emp_id
              ? {
                ...assignedEmployee,
                production_start_datetime: null,
                isProductionStarted: false,
              }
              : assignedEmployee
          )
        );

        setSnackbarMessage("Production ended successfully.");
        setSnackbarSeverity("success");
        setSnackbarOpen(true);
      }
    } catch (error) {
      console.error("Error ending production:", error);
      setSnackbarMessage("Error ending production.");
      setSnackbarSeverity("error");
      setSnackbarOpen(true);
    }
  };

  const handleProductionClick = (employee) => {
    console.log("Employee selected for production:", employee);

    const selectedEmployee = {
      empId: employee.emp_id,
      empName: employee.emp_name,
      jobNumber: employee.job.jobNumber,
      customer: employee.job.customer,
      job_started_time: employee.job.job_started_time,
      mainoperation: employee.job.mainoperation,
      product: employee.job.product,
    };

    setCurrentProductionEmployee(selectedEmployee);
    setProductionConfirmOpen(true);
    console.log("selected employee data", selectedEmployee)
  };


  const handleProductionConfirm = async () => {
    if (!currentProductionEmployee) {
      console.error('No employee selected for production');
      setSnackbarMessage("No employee selected for production.");
      setSnackbarSeverity("error");
      setSnackbarOpen(true);
      return;
    }

    const dataToSend = {
      supervisor_id: supervisorId,
      emp_id: currentProductionEmployee.empId,
      emp_name: currentProductionEmployee.empName,
      station_code: machineCode,
      job_number: currentProductionEmployee.jobNumber,
      customer: currentProductionEmployee.customer,
      product: currentProductionEmployee.product,
      main_operation: currentProductionEmployee.mainoperation,
      operation_description: "production",
      operation_type: "production",
      operation_code: "PROD",
      start_datetime: new Date().toISOString(),
      active_status: "ongoing",
      job_started_time: currentProductionEmployee.job_started_time
    };

    console.log("Data to send for production:", dataToSend);

    try {
      const response = await axios.post(`${API_BASE_URL}/manhourprodstart`, dataToSend);

      if (response.status === 200) {
        const insertedData = response.data.inserted_data;
        console.log("Production started data", insertedData);

        setAssignedEmployees((prevAssigned) =>
          prevAssigned.map((employee) =>
            employee.emp_id === insertedData.emp_id
              ? {
                ...employee,
                production_start_datetime: insertedData.start_datetime,
                isProductionStarted: true,
              }
              : employee
          )
        );

        // 🔧 ADD THIS: Reset job selection state after individual production start
        setSelectedJobEmployees((prevSelected) => {
          const newSelected = new Set(prevSelected);
          newSelected.delete(currentProductionEmployee.empId);

          // If this was the last selected employee, reset checkbox mode
          if (newSelected.size === 0) {
            setJobCheckboxMode(null);
          }

          return newSelected;
        });

        setSnackbarMessage("Production started successfully.");
        setSnackbarSeverity("success");
        setSnackbarOpen(true);
        setProductionConfirmOpen(false);
      }
    } catch (error) {
      console.error("Error starting production:", error);
      setSnackbarMessage("Error starting production.");
      setSnackbarSeverity("error");
      setSnackbarOpen(true);
    }
  };



  const handleAddJob = (jobStartData) => {
    if (!jobStartData || jobStartData.length === 0) {
      console.error('No job start data received');
      return;
    }

    console.log('Job Assignments:', jobStartData);

    function isEmployeeNotInJobList(employee, jobStartData) {
      return !jobStartData.some((job) => job.emp_id === employee.empId);
    }

    // Get the employee IDs that are being moved to jobs
    const movedEmployeeIds = jobStartData.map(job => job.emp_id);

    setEmployeeList((prevList) => {
      return prevList.filter((employee) => isEmployeeNotInJobList(employee, jobStartData));
    });

    setAssignedEmployees((prevAssigned) => [
      ...prevAssigned,
      ...jobStartData.map((job) => ({
        emp_name: job.emp_name,
        emp_id: job.emp_id,
        job: {
          jobNumber: job.job_number,
          customer: job.customer,
          mainoperation: job.main_operation,
          upCount: job.up_count,
          product: job.product,
          job_started_time: job.start_datetime
        },
      })),
    ]);

    // 🔧 ADD THIS: Reset selection state for employees moved to jobs
    setSelectedEmployees((prevSelected) => {
      const newSelected = new Set(prevSelected);

      // Remove all employees that were moved to jobs
      movedEmployeeIds.forEach(empId => {
        newSelected.delete(empId);
      });

      // If no employees remain selected, reset checkbox mode
      if (newSelected.size === 0) {
        setCheckboxMode(null);
      }

      return newSelected;
    });
  };

  const handleSnackbarClose = () => setSnackbarOpen(false);

  const handleConfirmRemoveOpen = (employee) => {
    setEmployeeToRemove(employee);
    setConfirmRemoveOpen(true);
  };

  const handleConfirmRemoveClose = () => {
    setConfirmRemoveOpen(false);
  };

  const handleRemoveConfirm = () => {
    if (employeeToRemove) {
      handleRemoveFromWorkstation(employeeToRemove.empId);
    }
    setConfirmRemoveOpen(false);
  };

  const handleAddEmployees = (newEmployees) => {
    const updatedEmployeeList = [...employeeList];

    newEmployees.forEach((employee) => {
      const isAlreadyAdded = updatedEmployeeList.some(e => e.empId === employee.empId);
      if (!isAlreadyAdded) {
        updatedEmployeeList.push(employee);
      }
    });

    setEmployeeList(updatedEmployeeList);
    console.log("Updated2 employee list:", updatedEmployeeList);
  };

  const handleOngoingDialogOpen = (employee) => {
    setCurrentEmployee(employee);
    setIsOngoingModalOpen(true);
  };

  const handleOngoingDialogClose = () => {
    setIsOngoingModalOpen(false);
  };


  const handleClickOpen = (employee) => {
    setCurrentEmployee(employee);
    // Set bulkEmployeeList with single employee for consistent handling
    setBulkEmployeeList([employee]);
    fetchIdleTimes();
  };



  const fetchIdleTimes = () => {
    axios
      .get(`${API_BASE_URL}/generalcodebymachinecode/${machineCode}`)
      .then((response) => {
        setIdleTimesData(response.data);
        setOpen(true);
      })
      .catch((error) => {
        console.error("Error fetching idle times:", error);
      });
  };


  const handleSecondDialogOpen = (item) => {
    setSelectedJob(item);
    setIsSecondModalOpen(true);
  };



  const handleProceed = async () => {
    setIsSubmitting(true);

    const operationType =
      ["IT-DT", "IT-LT", "IT-TT"].includes(selectedJob?.code)
        ? "General-Meals"
        : "General-Idle";

    // Handle both single employee and bulk employee cases
    const employeesToProcess = bulkEmployeeList.length > 0 ? bulkEmployeeList : [currentEmployee];

    for (const employee of employeesToProcess) {
      const dataToSend = {
        supervisor_id: supervisorId,
        emp_id: employee.empId,
        emp_name: employee.empName,
        station_code: machineCode,
        operation_code: selectedJob?.code,
        operation_description: selectedJob?.process,
        start_datetime: new Date().toISOString(),
        active_status: "ongoing",
        operation_type: operationType,
      };

      try {
        const response = await axios.post(`${API_BASE_URL}/manhouridleupdate`, dataToSend);
        if (response.status === 200) {
          const { start_datetime } = response.data;
          setEmployeeList((prevList) =>
            prevList.map((emp) =>
              emp.empId === employee.empId
                ? {
                  ...emp,
                  startedAt: start_datetime,
                  ongoingProcessCode: selectedJob?.code,
                }
                : emp
            )
          );
        }
      } catch (error) {
        console.error("Error starting idle time for", employee.empName, error);
      }
    }

    // Reset states
    setSelectedEmployees(new Set());
    setBulkEmployeeList([]);
    setOpen(false);
    setIsSecondModalOpen(false);
    setIsSubmitting(false);
    setSnackbarMessage("Idle time assigned successfully.");
    setSnackbarSeverity("success");
    setSnackbarOpen(true);
    setCheckboxMode(null);
  };



  const handleEndOperation = () => {
    const endDatetime = new Date().toISOString();

    const dataToSend = {
      supervisor_id: supervisorId,
      emp_id: currentEmployee?.empId,
      station_code: machineCode,
      operation_code: currentEmployee?.ongoingProcessCode,
      start_datetime: currentEmployee?.startedAt,
      end_datetime: endDatetime,
      active_status: "ended",
    };

    const updateEmployee = (employee) => {
      if (employee.empId === currentEmployee.empId) {
        return {
          ...employee,
          startedAt: null,
          ongoingProcessCode: null
        };
      }
      return employee;
    };

    axios.post(`${API_BASE_URL}/manhouridleend`, dataToSend)
      .then((response) => {
        setEmployeeList((prevList) => prevList.map(updateEmployee));
        setIsOngoingModalOpen(false);
      })
      .catch((error) => {
        console.error("Error ending operation:", error);
      });
  };


  const handleRemoveFromWorkstation = async (employeeId) => {
    const removalTime = new Date().toISOString();
    const dataToSend = {
      supervisor_id: supervisorId,
      machine_code: machineCode,
      emp_id: employeeId,
      shift_out_datetime: removalTime
    };

    console.log("Removing from workstation:", dataToSend);

    try {
      const response = await axios.post(`${API_BASE_URL}/manhourshiftout`, dataToSend);

      if (response.status === 200) {
        console.log("Removed from workstation successfully:", response.data);

        // Update employee list
        setEmployeeList((prevList) => prevList.filter(employee => employee.empId !== employeeId));

        // 🔧 ADD THIS: Reset selection state after individual removal
        setSelectedEmployees((prevSelected) => {
          const newSelected = new Set(prevSelected);
          newSelected.delete(employeeId);

          // If this was the last selected employee, reset checkbox mode
          if (newSelected.size === 0) {
            setCheckboxMode(null);
          }

          return newSelected;
        });

        setSnackbarMessage("Employee removed from workstation successfully.");
        setSnackbarSeverity("success");
      }
    } catch (error) {
      console.error("Error removing from workstation:", error);
      setSnackbarMessage("Error removing employee from workstation.");
      setSnackbarSeverity("error");
    } finally {
      setSnackbarOpen(true);
    }
  };

  return (
    <>
      {(!supervisorId || !machineCode) ? (
        <div>Error: Missing data. Please try again.</div>
      ) : (
        <>
          {/* SECOND HEADER LEVEL - Job and Shift Management */}

          {/* COMBINED SINGLE HEADER */}


          <Box sx={{ display: 'flex', flexDirection: 'column', gap: 3 }}>
            {/* Available Employees Section */}



            <Paper elevation={2} sx={{
              background: 'linear-gradient(135deg, #4fc3f7 0%, #29b6f6 100%)',
              borderRadius: '8px 8px 0 0',
              mb: 2,
              
              minHeight: '80px',
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'space-between'
            }}>
              <Toolbar sx={{ minHeight: '80px', px: 3 }}>
                {/* Left Section - Station Info */}

                {/* Center Section - Available Employees Info */}
                <Box sx={{ display: 'flex', alignItems: 'center', gap: 2 }}>
                  <Box sx={{ display: 'flex', alignItems: 'center', gap: 1.5 }}>
                    <GroupsIcon sx={{ fontSize: 28, color: 'white' }} />
                    <Typography variant="h6" sx={{
                      fontWeight: 600,
                      color: 'white',
                      display: 'flex',
                      alignItems: 'center',
                      gap: 2.5
                    }}>
                      Available Employees
                      <Badge
                        badgeContent={employeeList.length}
                        color="secondary"
                      />
                    </Typography>

                    {/* Add this Select All checkbox */}
                    {selectedEmployees.size > 0 && (
                      <Box sx={{ display: 'flex', alignItems: 'center', ml: 1 }}>
                        <Checkbox
                          checked={
                            checkboxMode === 'idle'
                              ? employeeList.filter(e => !e.startedAt).length === selectedEmployees.size
                              : employeeList.filter(e => e.startedAt).length === selectedEmployees.size
                          }
                          onChange={() => {
                            if (checkboxMode === 'idle') {
                              const idleEmployees = employeeList.filter(e => !e.startedAt);
                              if (selectedEmployees.size === idleEmployees.length) {
                                setSelectedEmployees(new Set());
                              } else {
                                setSelectedEmployees(new Set(idleEmployees.map(e => e.empId)));
                              }
                            } else if (checkboxMode === 'ongoing') {
                              const ongoingEmployees = employeeList.filter(e => e.startedAt);
                              if (selectedEmployees.size === ongoingEmployees.length) {
                                setSelectedEmployees(new Set());
                              } else {
                                setSelectedEmployees(new Set(ongoingEmployees.map(e => e.empId)));
                              }
                            }
                          }}
                          size="small"
                          sx={{
                            color: 'white',
                            '&.Mui-checked': { color: 'white' },
                            '& .MuiSvgIcon-root': { fontSize: 20 }
                          }}
                        />
                        <Typography variant="body2" sx={{ color: 'white', fontWeight: 500 }}>
                          Select All {checkboxMode === 'idle' ? 'Idle' : 'Ongoing'}
                        </Typography>
                      </Box>
                    )}

                    {selectedEmployees.size > 0 && (
                      <Chip
                        label={`${selectedEmployees.size} selected`}
                        size="small"
                        sx={{
                          backgroundColor: 'rgba(255,255,255,0.2)',
                          color: 'white',
                          fontWeight: 600,
                          height: 26,
                          fontSize: '0.75rem',
                        }}
                      />
                    )}
                  </Box>

                  {/* Divider */}
                  <Box sx={{
                    width: '2px',
                    height: '40px',
                    backgroundColor: 'rgba(255,255,255,0.3)',
                    mx: 1
                  }} />

                  {/* Job Summary */}
                  <Tooltip title="Active Jobs">
                    <Chip
                      icon={<AssignmentIcon />}
                      label={`${assignedEmployees.length} On Jobs`}
                      sx={{
                        backgroundColor: 'rgba(255,255,255,0.2)',
                        color: 'white',
                        fontWeight: 600,
                        height: 32,
                        '& .MuiChip-icon': { color: 'white' }
                      }}
                    />
                  </Tooltip>
                </Box>

                {/* Right Section - Action Buttons */}
                <Box sx={{ display: 'flex', gap: 2, alignItems: 'center', ml: 2 }}>
                  {/* Bulk Action Buttons */}
                  <Box sx={{ display: 'flex', gap: 1 }}>
                    <Button
                      variant="contained"
                      size="small"
                      onClick={() => handleBulkAction('idle')}
                      disabled={selectedEmployees.size === 0 || checkboxMode !== 'idle'}
                      startIcon={<PauseCircleOutlineIcon sx={{ fontSize: 16 }} />}
                      sx={{
                        minWidth: 120,
                        height: 32,
                        fontSize: '0.75rem',

                        backgroundColor: 'rgba(255,255,255,0.9)',
                        color: '#1976d2',
                        border: '1px solid rgba(255,255,255,0.2)',
                        fontWeight: 600,


                        '&:disabled': { opacity: 0.4 },
                        transition: 'all 0.2s cubic-bezier(0.4, 0, 0.2, 1)'
                      }}
                    >
                      Assign Idle
                    </Button>
                    <Button
                      variant="contained"
                      size="small"
                      onClick={() => handleBulkAction('remove')}
                      disabled={selectedEmployees.size === 0 || checkboxMode !== 'idle'}
                      startIcon={<PersonRemoveIcon sx={{ fontSize: 16 }} />}
                      sx={{
                        minWidth: 100,
                        height: 32,
                        fontSize: '0.75rem',
                        backgroundColor: 'rgba(244,67,54,0.8)',
                        color: 'white',


                        '&:disabled': { opacity: 0.4 },
                        transition: 'all 0.2s cubic-bezier(0.4, 0, 0.2, 1)'
                      }}
                    >
                      Remove
                    </Button>
                    <Button
                      variant="contained"
                      size="small"
                      onClick={handleBulkOngoingEnd}
                      disabled={selectedEmployees.size === 0 || checkboxMode !== 'ongoing'}
                      startIcon={<TaskAltIcon sx={{ fontSize: 16 }} />}
                      sx={{
                        minWidth: 100,
                        height: 32,
                        fontSize: '0.75rem',
                        backgroundColor: 'rgba(76,175,80,0.8)',
                        color: 'white',


                        '&:disabled': { opacity: 0.4 },
                        transition: 'all 0.2s cubic-bezier(0.4, 0, 0.2, 1)'
                      }}
                    >
                      End All
                    </Button>
                  </Box>

                  {/* Divider */}
                  <Box sx={{
                    width: '2px',
                    height: '40px',
                    backgroundColor: 'rgba(255,255,255,0.3)',
                    mx: 1
                  }} />

                  {/* Shift Add Button */}
                  <Tooltip title="Add employees to shift">
                    <Box sx={{
                      '& button': {
                        backgroundColor: 'rgba(255,255,255,0.2)',
                        color: 'white',
                        border: '2px solid rgba(255,255,255,0.3)',

                        transition: 'all 0.3s ease',
                      }
                    }}>
                      <ShiftAddButton
                        groupCode={Groupcode}
                        machineCode={machineCode}
                        supervisorId={supervisorId}
                        onAddEmployees={handleAddEmployees}
                        onTriggerSnackbar={onTriggerSnackbar}
                      />
                    </Box>
                  </Tooltip>
                </Box>
              </Toolbar>

            </Paper>
            <CardContent sx={{ p: 0 }}>
              {/* Compact Header */}
              {/* Compact Employee Grid - Two per row */}
              <Box sx={{
                maxHeight: 350,
                overflowY: 'auto',
                p: 1,
                '&::-webkit-scrollbar': { width: 8 },
                '&::-webkit-scrollbar-track': {
                  backgroundColor: theme.palette.grey[100],
                  borderRadius: 4
                },
                '&::-webkit-scrollbar-thumb': {
                  backgroundColor: theme.palette.primary.main,
                  borderRadius: 4,
                }
              }}>
                {employeeList.length === 0 ? (
                  <Box sx={{
                    p: 1,
                    textAlign: 'center',
                    color: theme.palette.text.secondary
                  }}>
                    {/* <GroupsIcon sx={{ fontSize: 48, opacity: 0.3, mb: 1 }} /> */}
                    {/* <GroupsIcon sx={{
                      fontSize: 48,
                      opacity: 0.3,
                      mb: 1,
                    }} /> */}
                    <Typography variant="body1" sx={{ fontWeight: 500, mb: 0.5 }}>
                      No Available Employees
                    </Typography>
                    <Typography variant="body2" sx={{ fontSize: '0.85rem' }}>
                      Add employees to the shift to get started
                    </Typography>
                  </Box>
                ) : (
                  <Box sx={{
                    display: 'flex',
                    flexDirection: 'column',
                    gap: 1
                  }}>
                    {/* Group employees in pairs for two-per-row layout */}
                    {Array.from({ length: Math.ceil(employeeList.length / 2) }, (_, rowIndex) => {
                      const startIndex = rowIndex * 2;
                      const rowEmployees = employeeList.slice(startIndex, startIndex + 2);

                      return (

                        <Box
                          key={`row-${rowIndex}`}
                          sx={{
                            display: 'flex',
                            gap: 1,
                            '& > *': { flex: '1 1 0' },
                          }}
                        >


                          {rowEmployees.map((employee) => (
                            <Paper
                              key={employee.empId}
                              elevation={selectedEmployees.has(employee.empId) ? 3 : 1}
                              sx={{
                                p: 1,
                                height: 50,
                                display: 'flex',
                                alignItems: 'center',
                                borderRadius: 2,
                                backgroundColor: selectedEmployees.has(employee.empId)
                                  ? alpha(theme.palette.primary.light, 0.12)
                                  : 'white',
                                border: selectedEmployees.has(employee.empId)
                                  ? `1px solid ${theme.palette.primary.main}`
                                  : `1px solid ${theme.palette.divider}`,
                                cursor: 'pointer',
                                transition: 'all 0.2s ease',

                              }}
                              onClick={(e) => {
                                if (!e.target.closest('input[type="checkbox"]') && !e.target.closest('button')) {
                                  toggleEmployeeSelection(employee.empId);
                                }
                              }}
                            >
                              {/* Checkbox - larger */}
                              <Checkbox
                                checked={selectedEmployees.has(employee.empId)}
                                onChange={(e) => {
                                  e.stopPropagation();
                                  toggleEmployeeSelection(employee.empId);
                                }}
                                disabled={
                                  (checkboxMode === 'ongoing' && !employee.startedAt) ||
                                  (checkboxMode === 'idle' && !!employee.startedAt)
                                }
                                size="medium"
                                sx={{
                                  p: 1,
                                  mr: 1.5,
                                  flexShrink: 0,
                                  '&.Mui-checked': { color: theme.palette.primary.main }
                                }}
                              />

                              {/* Employee Info - with chips for name and ID */}
                              <Box sx={{
                                flex: '1 1 auto',
                                minWidth: 0,
                                mr: 2,
                              }}>
                                {/* All chips in single horizontal line with more spacing */}
                                <Box sx={{
                                  display: 'flex',
                                  gap: 1, // Increased gap between chips
                                  alignItems: 'center',
                                  flexWrap: 'wrap'
                                }}>
                                  {/* Employee Name Chip - larger */}
                                  <Chip
                                    label={employee.empName || `Employee ${employee.empId}`}
                                    size="medium" // Changed from small to medium
                                    sx={{
                                      height: 24, // Increased height
                                      fontSize: '0.8rem', // Larger font
                                      fontWeight: 600,
                                      backgroundColor: theme.palette.primary.light,
                                      color: theme.palette.primary.contrastText,
                                      '& .MuiChip-label': {
                                        px: 1, // Increased padding
                                        maxWidth: '140px', // Wider max width
                                        overflow: 'hidden',
                                        textOverflow: 'ellipsis'
                                      }
                                    }}
                                  />

                                  {/* Employee ID Chip - larger */}
                                  <Chip
                                    label={`ID: ${employee.empId}`}
                                    size="medium" // Changed from small to medium
                                    variant="outlined"
                                    sx={{
                                      height: 24, // Increased height
                                      fontSize: '0.8rem', // Larger font
                                      fontWeight: 500,
                                      borderColor: theme.palette.primary.main,
                                      color: theme.palette.primary.main,
                                      '& .MuiChip-label': { px: 1 } // Increased padding
                                    }}
                                  />

                                  {/* Status Chip - larger with "since" information */}
                                  {employee.startedAt ? (
                                    <Chip
                                      label={`${employee.ongoingProcessCode} since ${new Date(employee.startedAt).toLocaleTimeString()}`}
                                      color="warning"
                                      size="medium" // Changed from small to medium
                                      sx={{
                                        height: 24, // Increased height
                                        fontSize: '0.8rem', // Larger font
                                        fontWeight: 600,

                                      }}
                                    />
                                  ) : (
                                    <Chip
                                      label="Available"
                                      color="success"
                                      variant="outlined"
                                      size="medium" // Changed from small to medium
                                      sx={{
                                        height: 24, // Increased height
                                        fontSize: '0.8rem', // Larger font
                                        fontWeight: 600
                                      }}
                                    />
                                  )}
                                </Box>
                              </Box>

                              {/* Actions - larger and more prominent */}
                              <Box sx={{
                                display: 'flex',
                                gap: 1,
                                flexShrink: 0
                              }}>
                                <Tooltip title={employee.startedAt ? "End process" : "Assign idle"}>
                                  <IconButton
                                    onClick={(e) => {
                                      e.stopPropagation();
                                      employee.startedAt
                                        ? handleOngoingDialogOpen(employee)
                                        : handleClickOpen(employee);
                                    }}
                                    color={employee.startedAt ? "error" : "primary"}
                                    size="medium"
                                    sx={{
                                      width: 32,
                                      height: 32,
                                      backgroundColor: alpha(
                                        employee.startedAt ? theme.palette.error.main : theme.palette.primary.main,
                                        0.1
                                      ),
                                      '& .MuiSvgIcon-root': {
                                        fontSize: 18,

                                      }
                                    }}
                                  >
                                    {employee.startedAt ? <HourglassTopIcon /> : <PauseCircleOutlineIcon />}
                                  </IconButton>
                                </Tooltip>

                                <Tooltip title="Remove">
                                  <IconButton
                                    onClick={(e) => {
                                      e.stopPropagation();
                                      handleConfirmRemoveOpen(employee);
                                    }}
                                    disabled={!!employee.startedAt}
                                    color="error"
                                    size="medium"
                                    sx={{
                                      width: 32,
                                      height: 32,
                                      backgroundColor: alpha(theme.palette.error.main, 0.1),
                                      '&:disabled': { opacity: 0.3 },
                                      '& .MuiSvgIcon-root': { fontSize: 18 }
                                    }}
                                  >
                                    <PersonRemoveIcon />
                                  </IconButton>
                                </Tooltip>
                              </Box>
                            </Paper>
                          ))}


                          {/* If odd number of employees, add empty space to maintain layout */}
                          {rowEmployees.length === 1 && (
                            <Box sx={{ flex: '1 1 0' }} />
                          )}
                        </Box>
                      );
                    })}
                  </Box>
                )}
              </Box>

              {/* Optional: Time display for ongoing processes */}
              {employeeList.some(emp => emp.startedAt) && (
                <Box sx={{
                  p: 1,
                  backgroundColor: alpha(theme.palette.warning.main, 0.05),
                  borderTop: `1px solid ${theme.palette.divider}`,
                  display: 'flex',
                  justifyContent: 'space-between',
                  alignItems: 'center'
                }}>
                  {/* Left Section - Ongoing Processes */}
                  <Typography variant="caption" sx={{
                    color: theme.palette.text.secondary,
                    fontStyle: 'italic'
                  }}>
                    Ongoing processes: {employeeList.filter(emp => emp.startedAt).length} employee(s)
                  </Typography>

                  {/* Right Section - Selection Mode */}
                  {checkboxMode && (
                    <Typography variant="body2" sx={{
                      color: theme.palette.primary.main,
                      fontWeight: 500,
                      fontSize: '0.8rem',

                    }}>
                      Selection Mode: {checkboxMode === 'idle' ? 'Assign Idle or Remove' : 'Ongoing Idle Employees'}
                    </Typography>
                  )}
                </Box>
              )}
            </CardContent>



            {/* UPDATED TABLE HEADER WITH BULK CONTROLS - Enhanced */}
            <Box sx={{
              p: 0.5,
              borderBottom: '2px solid',
              borderColor: 'divider',
              display: 'flex',
              justifyContent: 'space-between',
              alignItems: 'center',
              background: 'linear-gradient(135deg, #e8f5e8 0%, #c8e6c9 100%)',
              position: 'sticky',
              top: 0,
              zIndex: 10
            }}>
              {/* Left Section - Job Info with Enhanced Icons */}

              <Typography variant="h6" sx={{
                fontWeight: 600,
                color: '#2e7d32',
                display: 'flex',
                alignItems: 'center',
                gap: 2.5
              }}>
                Active Jobs
                <Badge
                  badgeContent={assignedEmployees.length}
                  color="secondary"
                  sx={{
                    marginLeft: '5px',

                  }}
                />
              </Typography>

              {/* Enhanced Select All Checkbox */}
              {selectedJobEmployees.size > 0 && (
                <Box sx={{
                  display: 'flex',
                  alignItems: 'center',
                  ml: 1,
                  p: 1,
                  borderRadius: 1,
                  backgroundColor: 'rgba(46,125,50,0.1)',
                  border: '1px solid rgba(46,125,50,0.3)'
                }}>
                  <Checkbox
                    checked={
                      jobCheckboxMode === 'available'
                        ? assignedEmployees.filter(e => !e.isProductionStarted && !e.isIdleStarted).length === selectedJobEmployees.size
                        : jobCheckboxMode === 'production'
                          ? assignedEmployees.filter(e => e.isProductionStarted).length === selectedJobEmployees.size
                          : assignedEmployees.filter(e => e.isIdleStarted).length === selectedJobEmployees.size
                    }
                    onChange={() => {
                      const relevantEmployees = assignedEmployees.filter(e => {
                        if (jobCheckboxMode === 'available') return !e.isProductionStarted && !e.isIdleStarted;
                        if (jobCheckboxMode === 'production') return e.isProductionStarted;
                        if (jobCheckboxMode === 'idle') return e.isIdleStarted;
                        return false;
                      });

                      if (selectedJobEmployees.size === relevantEmployees.length) {
                        setSelectedJobEmployees(new Set());
                        setJobCheckboxMode(null);
                      } else {
                        setSelectedJobEmployees(new Set(relevantEmployees.map(e => e.emp_id)));
                      }
                    }}
                    size="small"
                    sx={{
                      color: '#2e7d32',
                      '&.Mui-checked': { color: '#2e7d32' },
                      '& .MuiSvgIcon-root': { fontSize: 20 }
                    }}
                  />
                  <Typography variant="body2" sx={{ color: '#2e7d32', fontWeight: 600, fontSize: '0.8rem' }}>
                    Select All {jobCheckboxMode === 'available' ? 'Available' : jobCheckboxMode === 'production' ? 'Production' : 'Idle'}
                  </Typography>
                </Box>
              )}

              {/* Enhanced Selection Counter */}
              {selectedJobEmployees.size > 0 && (
                <Chip
                  label={`${selectedJobEmployees.size} selected`}
                  size="small"
                  sx={{
                    backgroundColor: '#2e7d32',
                    color: 'white',
                    fontWeight: 600,
                    height: 28,
                    fontSize: '0.75rem',

                  }}
                />
              )}


              {/* Enhanced Center Section - Bulk Action Buttons with Better Grouping */}
              <Box sx={{ display: 'flex', gap: 1 }}>
                {/* Start Actions Group */}
                <Box sx={{
                  display: 'flex',
                  gap: 0.5,
                  p: 0.5,
                  borderRadius: 1,
                  backgroundColor: 'rgba(255,255,255,0.7)',
                  border: '1px solid rgba(0,0,0,0.1)'
                }}>
                  <Button
                    variant="contained"
                    size="small"
                    onClick={() => handleBulkJobAction('idle')}
                    disabled={selectedJobEmployees.size === 0 || jobCheckboxMode !== 'available'}
                    startIcon={<PauseCircleOutlineIcon sx={{ fontSize: 16 }} />}
                    sx={{
                      minWidth: 100,
                      height: 32,
                      fontSize: '0.75rem',
                      backgroundColor: '#2196f3',
                      color: 'white',
                      borderRadius: 1,
                      '&:disabled': { opacity: 0.4 },
                      transition: 'all 0.2s ease'
                    }}
                  >
                    Start Idle
                  </Button>

                  <Button
                    variant="contained"
                    size="small"
                    onClick={() => handleBulkJobAction('production')}
                    disabled={selectedJobEmployees.size === 0 || jobCheckboxMode !== 'available'}
                    startIcon={<WorkIcon sx={{ fontSize: 16 }} />}
                    sx={{
                      minWidth: 120,
                      height: 32,
                      fontSize: '0.75rem',
                      backgroundColor: '#4caf50',
                      color: 'white',
                      borderRadius: 1,

                      '&:disabled': { opacity: 0.4 },
                      transition: 'all 0.2s ease'
                    }}
                  >
                    Start Production
                  </Button>
                </Box>

                {/* End Actions Group */}
                <Box sx={{
                  display: 'flex',
                  gap: 0.5,
                  p: 0.5,
                  borderRadius: 1,
                  backgroundColor: 'rgba(255,255,255,0.7)',
                  border: '1px solid rgba(0,0,0,0.1)'
                }}>
                  <Button
                    variant="contained"
                    size="small"
                    onClick={() => handleBulkJobAction('endProduction')}
                    disabled={selectedJobEmployees.size === 0 || jobCheckboxMode !== 'production'}
                    startIcon={<TaskAltIcon sx={{ fontSize: 16 }} />}
                    sx={{
                      minWidth: 120,
                      height: 32,
                      fontSize: '0.75rem',
                      backgroundColor: '#ff9800',
                      color: 'white',
                      borderRadius: 1,

                      '&:disabled': { opacity: 0.4 },
                      transition: 'all 0.2s ease'
                    }}
                  >
                    End Production
                  </Button>

                  <Button
                    variant="contained"
                    size="small"
                    onClick={() => handleBulkJobAction('endIdle')}
                    disabled={selectedJobEmployees.size === 0 || jobCheckboxMode !== 'idle'}
                    startIcon={<TaskAltIcon sx={{ fontSize: 16 }} />}
                    sx={{
                      minWidth: 100,
                      height: 32,
                      fontSize: '0.75rem',
                      backgroundColor: '#9c27b0',
                      color: 'white',
                      borderRadius: 1,
                      '&:disabled': { opacity: 0.4 },
                      transition: 'all 0.2s ease'
                    }}
                  >
                    End Idle
                  </Button>
                </Box>
              </Box>

              {/* Enhanced Right Section - Job Add Button */}
              <Box sx={{
                '& button': {
                  boxShadow: '0 2px 8px rgba(0,0,0,0.15)',
                  transition: 'all 0.3s ease'
                }
              }}>
                <JobAddButton
                  supervisorId={supervisorId}
                  machineCode={machineCode}
                  groupCode={Groupcode}
                  onAddJob={handleAddJob}
                  onTriggerSnackbar={onTriggerSnackbar}
                />
              </Box>
            </Box>



            <Box sx={{
              maxHeight: 600,
              overflowY: 'auto',
              p: 2,
              '&::-webkit-scrollbar': { width: 8 },
              '&::-webkit-scrollbar-track': {
                backgroundColor: '#f5f5f5',
                borderRadius: 4
              },
              '&::-webkit-scrollbar-thumb': {
                backgroundColor: '#c4c4c4',
                borderRadius: 4,
              }
            }}>
              {assignedEmployees.length === 0 ? (
                /* Empty State */
                <Box sx={{
                  display: 'flex',
                  flexDirection: 'column',
                  alignItems: 'center',
                  gap: 2,
                  py: 8,
                  color: 'text.secondary'
                }}>
                  <WorkIcon sx={{
                    fontSize: 64,
                    opacity: 0.3,

                  }} />
                  <Typography variant="h6" sx={{ fontWeight: 500 }}>
                    No Active Jobs
                  </Typography>
                  <Typography variant="body2" sx={{ maxWidth: 300, textAlign: 'center' }}>
                    Assign jobs to employees to start tracking their work progress and operations.
                  </Typography>
                </Box>
              ) : (
                /* Two-Column Grid Layout */
                <Box sx={{
                  display: 'grid',
                  gridTemplateColumns: 'repeat(3, 1fr)',
                  gap: 2,
                  alignItems: 'start'
                }}>
                  {assignedEmployees
                    .filter((employee) => employee.job)
                    .map((employee, index) => (
                      <Paper
                        key={employee.emp_id}
                        elevation={selectedJobEmployees.has(employee.emp_id) ? 4 : 2}
                        sx={{
                          p: 2,
                          borderRadius: 3,
                          backgroundColor: selectedJobEmployees.has(employee.emp_id)
                            ? alpha(theme.palette.primary.light, 0.15)
                            : 'white',
                          border: selectedJobEmployees.has(employee.emp_id)
                            ? `2px solid ${theme.palette.primary.main}`
                            : '1px solid #e0e0e0',
                          cursor: 'pointer',
                          transition: 'all 0.3s ease',
                          height: 'auto',
                          minHeight: 110,
                          display: 'flex',
                          flexDirection: 'row',


                        }}
                        onClick={(e) => {
                          if (!e.target.closest('input[type="checkbox"]') && !e.target.closest('button')) {
                            toggleJobEmployeeSelection(employee.emp_id);
                          }
                        }}
                      >

                        {/* Main Content Area - 2 Column Grid Layout */}
                        <Box sx={{
                          flex: 1,
                          display: 'grid',
                          gridTemplateColumns: '130px 180px',  // or use your preferred widths
                          gap: 1.5,
                          pr: 1
                        }}>
                          {/* COLUMN 1: Employee Information (3 rows) */}
                          <Box sx={{ display: 'flex', flexDirection: 'column', gap: 0.8 }}>
                            {/* Row 1: Checkbox + Employee ID Badge */}
                            <Box sx={{ display: 'flex', alignItems: 'center', gap: 0.8 }}>
                              <Checkbox
                                checked={selectedJobEmployees.has(employee.emp_id)}
                                onChange={(e) => {
                                  e.stopPropagation();
                                  toggleJobEmployeeSelection(employee.emp_id);
                                }}
                                disabled={
                                  (jobCheckboxMode === 'production' && !employee.isProductionStarted) ||
                                  (jobCheckboxMode === 'idle' && !employee.isIdleStarted) ||
                                  (jobCheckboxMode === 'available' && (employee.isProductionStarted || employee.isIdleStarted))
                                }
                                size="small"
                                sx={{
                                  p: 0,
                                  '&.Mui-checked': {
                                    color: theme.palette.primary.main,

                                  },
                                  '&.Mui-disabled': { opacity: 0.3 },
                                  transition: 'all 0.2s ease'
                                }}
                              />
                              <Typography variant="caption" sx={{
                                color: 'text.secondary',
                                backgroundColor: alpha(theme.palette.primary.main, 0.1),
                                px: 0.5,
                                py: 0.1,
                                borderRadius: 0.5,
                                fontWeight: 500,
                                fontSize: '0.65rem',
                                display: 'inline-block'
                              }}>
                                ID: {employee.emp_id}
                              </Typography>
                            </Box>

                            {/* Row 2: Employee Name */}
                            <Box>
                              <Typography variant="body2" sx={{
                                fontWeight: 600,
                                lineHeight: 1.2,
                                overflow: 'hidden',
                                textOverflow: 'ellipsis',
                                whiteSpace: 'nowrap',
                                fontSize: '0.85rem'
                              }}>
                                {employee.emp_name || `Employee ${employee.emp_id}`}
                              </Typography>
                            </Box>

                            {/* Row 3: Status Chips */}
                            <Box sx={{ display: 'flex', flexDirection: 'column', gap: 0.5 }}>
                              {employee.isProductionStarted && (
                                <Chip
                                  icon={<WorkIcon sx={{ fontSize: 12 }} />}
                                  label="Production"
                                  size="small"
                                  sx={{
                                    backgroundColor: '#4caf50',
                                    color: 'white',
                                    fontSize: '0.65rem',
                                    height: 20,
                                    '& .MuiChip-label': { px: 0.5 },

                                  }}
                                />
                              )}
                              {employee.isIdleStarted && (
                                <Chip
                                  icon={<PauseIcon sx={{ fontSize: 12 }} />}
                                  label={employee.ongoingJobIdleCode}
                                  size="small"
                                  sx={{
                                    backgroundColor: '#ff9800',
                                    color: 'white',
                                    fontSize: '0.65rem',
                                    height: 20,
                                    '& .MuiChip-label': { px: 0.5 },

                                  }}
                                />
                              )}
                              {!employee.isProductionStarted && !employee.isIdleStarted && (
                                <Chip
                                  icon={<CheckCircleIcon sx={{ fontSize: 12 }} />}
                                  label="Ready"
                                  size="small"
                                  variant="outlined"
                                  sx={{
                                    borderColor: '#4caf50',
                                    color: '#4caf50',
                                    fontSize: '0.65rem',
                                    height: 20,
                                    '& .MuiChip-label': { px: 0.5 }
                                  }}
                                />
                              )}
                            </Box>
                          </Box>

                          {/* COLUMN 2: Job Details (3 rows) */}
                          <Box sx={{ display: 'flex', flexDirection: 'column', gap: 0.8, minWidth: 0 }}>
                            {employee.job ? (
                              <>
                                {/* Row 1: Job Number + Time */}
                                <Box sx={{ display: 'flex', alignItems: 'center', gap: 0.8, justifyContent: 'space-between' }}>
                                  <Chip
                                    icon={<AssignmentIcon sx={{ fontSize: 12 }} />}
                                    label={employee.job.jobNumber}
                                    variant="filled"
                                    sx={{
                                      backgroundColor: '#1976d2',
                                      color: 'white',
                                      fontWeight: 600,
                                      fontSize: '0.7rem',
                                      height: 22,
                                      '& .MuiChip-label': { px: 0.5 }
                                    }}
                                  />
                                  <Typography variant="caption" sx={{
                                    color: 'text.secondary',
                                    fontSize: '0.65rem',
                                    display: 'flex',
                                    alignItems: 'center',
                                    gap: 0.3,
                                    whiteSpace: 'nowrap'
                                  }}>
                                    <AccessTimeIcon sx={{ fontSize: 10 }} />
                                    {new Date(employee.job.job_started_time).toLocaleDateString('en-US', {
                                      month: 'short',
                                      day: 'numeric',
                                      hour: '2-digit',
                                      minute: '2-digit'
                                    })}
                                  </Typography>
                                </Box>

                                {/* Row 2: Customer */}
                                <Box>
                                  <Typography variant="caption" sx={{
                                    color: 'text.secondary',
                                    fontSize: '0.72rem',
                                    overflow: 'hidden',
                                    textOverflow: 'ellipsis',
                                    whiteSpace: 'nowrap',
                                    display: 'flex',
                                    alignItems: 'center',
                                    gap: 0.3
                                  }}>
                                    <PersonIcon sx={{ fontSize: 10 }} />
                                    {employee.job.customer}
                                  </Typography>
                                </Box>

                                {/* Row 3: Product */}
                                <Box>
                                  <Typography variant="caption" sx={{
                                    color: 'text.secondary',
                                    fontSize: '0.72rem',
                                    overflow: 'hidden',
                                    textOverflow: 'ellipsis',
                                    whiteSpace: 'nowrap',
                                    display: 'flex',
                                    alignItems: 'center',
                                    gap: 0.3
                                  }}>
                                    <InventoryIcon sx={{ fontSize: 10 }} />
                                    {employee.job.product}
                                  </Typography>
                                </Box>
                              </>
                            ) : (
                              <Typography variant="body2" sx={{ color: 'text.secondary', fontStyle: 'italic', fontSize: '0.8rem' }}>
                                No job information
                              </Typography>
                            )}
                          </Box>
                        </Box>

                        {/* Actions - Right Side - Vertical Stack with Minimal Width */}
                        <Box
                          className="action-buttons"
                          sx={{
                            opacity: 0.8,

                            transition: 'all 0.3s ease',
                            display: 'flex',
                            flexDirection: 'column',
                            gap: 0.5,
                            minWidth: 85,
                            justifyContent: 'center',
                            borderLeft: '1px solid rgba(0,0,0,0.1)',
                            pl: 1,
                            ml: 1
                          }}
                        >
                          {/* Primary Action - End Job */}
                          <Button
                            startIcon={<TaskAltIcon sx={{ fontSize: 14 }} />}
                            variant="contained"
                            size="small"
                            disabled={employee.isProductionStarted || employee.isIdleStarted}
                            onClick={(e) => {
                              e.stopPropagation();
                              handleEndJobClick(employee);
                            }}
                            sx={{
                              background: 'linear-gradient(45deg, #4caf50, #66bb6a)',
                              color: 'white',
                              fontWeight: 600,
                              borderRadius: 1.5,
                              height: 28,
                              fontSize: '0.7rem',
                              minWidth: 'auto',
                              px: 1,
                              boxShadow: '0 2px 6px rgba(76,175,80,0.3)',
                              '& .MuiButton-startIcon': {
                                mr: 0.5,
                                '& > svg': { fontSize: 14 }
                              },

                              '&.Mui-disabled': {
                                background: 'linear-gradient(45deg, #e0e0e0, #bdbdbd)',
                                color: '#9e9e9e',
                                boxShadow: 'none'
                              },
                              transition: 'all 0.2s ease'
                            }}
                          >
                            End
                          </Button>

                          {/* Secondary Actions - Two buttons in row */}
                          <Box sx={{ display: 'flex', gap: 0.5 }}>
                            {/* Status Toggle */}
                            <Button
                              variant="outlined"
                              size="small"
                              onClick={(e) => {
                                e.stopPropagation();
                                if (employee.isProductionStarted) {
                                  handleOpenEndConfirmDialog(employee, 'production');
                                } else if (employee.isIdleStarted) {
                                  handleOpenEndConfirmDialog(employee, 'idle');
                                } else {
                                  handleClickJobIdleOpen(employee);
                                }
                              }}
                              sx={{
                                fontSize: '0.65rem',
                                height: 26,
                                minWidth: 'auto',
                                px: 0.8,
                                flex: 1,
                                borderColor: employee.isProductionStarted || employee.isIdleStarted
                                  ? '#f44336'
                                  : '#2196f3',
                                color: employee.isProductionStarted || employee.isIdleStarted
                                  ? '#f44336'
                                  : '#2196f3',

                              }}
                            >
                              {employee.isProductionStarted || employee.isIdleStarted ? (
                                <StopIcon sx={{ fontSize: 12 }} />
                              ) : (
                                <PlayArrowIcon sx={{ fontSize: 12 }} />
                              )}
                            </Button>

                            {/* Production Quick Start */}
                            <Button
                              variant="outlined"
                              size="small"
                              disabled={employee.isProductionStarted || employee.isIdleStarted}
                              onClick={(e) => {
                                e.stopPropagation();
                                handleProductionClick(employee);
                              }}
                              sx={{
                                fontSize: '0.65rem',
                                height: 26,
                                minWidth: 'auto',
                                px: 0.8,
                                flex: 1,
                                borderColor: '#4caf50',
                                color: '#4caf50',

                                '&.Mui-disabled': {
                                  borderColor: '#e0e0e0',
                                  color: '#bdbdbd'
                                }
                              }}
                            >
                              <WorkIcon sx={{ fontSize: 12 }} />
                            </Button>
                          </Box>

                          {/* Status Indicator Dot */}
                          <Box sx={{
                            display: 'flex',
                            justifyContent: 'center',
                            mt: 0.5
                          }}>
                            <Box sx={{
                              width: 6,
                              height: 6,
                              borderRadius: '50%',
                              backgroundColor: employee.isProductionStarted
                                ? '#4caf50'
                                : employee.isIdleStarted
                                  ? '#ff9800'
                                  : '#e0e0e0',

                            }} />
                          </Box>
                        </Box>
                      </Paper>
                    ))}
                </Box>
              )}
            </Box>

            {/* Enhanced Table Container with Better Scroll */}
            <Box sx={{
              maxHeight: 600,
              overflowY: 'auto',
              '&::-webkit-scrollbar': { width: 8 },
              '&::-webkit-scrollbar-track': {
                backgroundColor: '#f5f5f5',
                borderRadius: 4
              },
              '&::-webkit-scrollbar-thumb': {
                backgroundColor: '#c4c4c4',
                borderRadius: 4,

              }
            }}>

            </Box>
            {/* Unified Footer Section with All Controls */}




          </Box>


          <Dialog
            open={isOngoingModalOpen}
            onClose={handleOngoingDialogClose}
            maxWidth="sm"
            fullWidth
            PaperProps={{
              sx: {
                borderRadius: 2,
                boxShadow: '0 20px 25px -5px rgba(0, 0, 0, 0.1), 0 10px 10px -5px rgba(0, 0, 0, 0.04)'
              }
            }}
          >
            {/* Header */}
            <DialogTitle sx={{ pb: 2 }}>
              <Box display="flex" alignItems="center" gap={2}>
                <Box
                  sx={{
                    width: 40,
                    height: 40,
                    bgcolor: 'error.light',
                    borderRadius: '50%',
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center'
                  }}
                >
                  <StopIcon sx={{ color: 'error.main' }} />
                </Box>
                <Box>
                  <Typography variant="h6" component="h2" fontWeight={600}>
                    Stop Ongoing operation
                  </Typography>
                  <Typography variant="body2" color="text.secondary">
                    Confirm process termination
                  </Typography>
                </Box>
              </Box>
            </DialogTitle>

            {/* Content */}
            <DialogContent sx={{ pt: 0, pb: 2 }}>
              <Alert
                severity="warning"
                icon={<WarningIcon />}
                sx={{
                  mb: 2,
                  '& .MuiAlert-message': {
                    fontSize: '0.95rem',
                    fontWeight: 500
                  }
                }}
              >
                This will immediately stop the ongoing process and cannot be undone.
              </Alert>

              <Box
                sx={{
                  textAlign: 'center',
                  p: 2,
                  bgcolor: 'grey.50',
                  borderRadius: 1,
                  border: '1px solid',
                  borderColor: 'grey.200'
                }}
              >
                <Typography variant="body1" color="text.primary" fontWeight={500}>
                  Are you sure you want to stop the current operation?
                </Typography>
              </Box>
            </DialogContent>

            {/* Actions */}
            <DialogActions sx={{ px: 3, pb: 3, gap: 1, justifyContent: 'center' }}>
              <Button
                onClick={handleOngoingDialogClose}
                variant="outlined"
                color="inherit"
                startIcon={<CloseIcon />}
                sx={{
                  minWidth: 100,
                  textTransform: 'none',
                  fontWeight: 500
                }}
              >
                Cancel
              </Button>
              <Button
                onClick={handleEndOperation}
                variant="contained"
                color="error"
                startIcon={<StopIcon />}
                autoFocus
                sx={{
                  minWidth: 120,
                  textTransform: 'none',
                  fontWeight: 500
                }}
              >
                Stop Job
              </Button>
            </DialogActions>
          </Dialog>



          {/* Enhanced Idle Times Dialog */}
          <Dialog
            open={open}
            onClose={() => setOpen(false)}
            fullWidth
            maxWidth="md"
            sx={{
              '& .MuiDialog-paper': {
                borderRadius: 3,
                boxShadow: '0 24px 48px rgba(0,0,0,0.15)',
                background: 'linear-gradient(145deg, #ffffff 0%, #f8f9fa 100%)',
                overflow: 'hidden'
              }
            }}
          >
            {/* Enhanced Dialog Title */}
            <DialogTitle sx={{
              background: 'linear-gradient(135deg, #e3f2fd 0%, #bbdefb 100%)',
              color: '#1565c0',
              textAlign: 'center',
              py: 3,
              borderBottom: '2px solid #e3f2fd'
            }}>
              <Box sx={{ display: 'flex', flexDirection: 'column', alignItems: 'center', gap: 1 }}>
                {/* Icon Header */}
                <Box sx={{
                  p: 2,
                  borderRadius: '50%',
                  backgroundColor: 'rgba(33,150,243,0.1)',
                  border: '2px solid rgba(33,150,243,0.2)'
                }}>
                  <PauseCircleOutlineIcon sx={{ fontSize: 32, color: '#2196f3' }} />
                </Box>

                {/* Title */}
                <Typography variant="h5" sx={{ fontWeight: 600, mb: 0.5 }}>
                  Select Idle Code
                </Typography>

                {/* Subtitle */}
                <Typography variant="body2" sx={{
                  color: 'text.secondary',
                  fontWeight: 500,
                  display: 'flex',
                  alignItems: 'center',
                  gap: 0.5
                }}>
                  <GroupsIcon sx={{ fontSize: 16 }} />
                  {bulkEmployeeList.length > 0
                    ? `${bulkEmployeeList.length} Selected Employee${bulkEmployeeList.length > 1 ? 's' : ''}`
                    : 'Current Employee'
                  }
                </Typography>

                {/* Employee Names for Bulk Selection */}
                {bulkEmployeeList.length > 0 && bulkEmployeeList.length <= 5 && (
                  <Box sx={{
                    display: 'flex',
                    gap: 0.5,
                    flexWrap: 'wrap',
                    justifyContent: 'center',
                    mt: 1
                  }}>
                    {bulkEmployeeList.map((emp, index) => (
                      <Chip
                        key={emp.empId || emp.emp_id}
                        label={emp.empName || emp.emp_name || `ID: ${emp.empId || emp.emp_id}`}
                        size="small"
                        sx={{
                          backgroundColor: 'rgba(33,150,243,0.1)',
                          color: '#2196f3',
                          fontWeight: 500,
                          fontSize: '0.7rem'
                        }}
                      />
                    ))}
                  </Box>
                )}

                {/* Show count if more than 5 employees */}
                {bulkEmployeeList.length > 5 && (
                  <Chip
                    label={`${bulkEmployeeList.length} employees selected`}
                    sx={{
                      backgroundColor: '#2196f3',
                      color: 'white',
                      fontWeight: 600,
                      mt: 1
                    }}
                  />
                )}
              </Box>
            </DialogTitle>

            {/* Enhanced Dialog Content */}
            <DialogContent sx={{
              px: 4,
              py: 3,
              minHeight: 200,
              display: 'flex',
              flexDirection: 'column'
            }}>
              {idleTimesData.length > 0 ? (
                <>
                  {/* Instructions */}
                  <Box sx={{
                    mb: 3,
                    p: 2,
                    backgroundColor: 'rgba(33,150,243,0.05)',
                    borderRadius: 2,
                    border: '1px solid rgba(33,150,243,0.1)'
                  }}>
                    <Typography variant="body2" sx={{
                      color: 'text.secondary',
                      textAlign: 'center',
                      fontStyle: 'italic',
                      display: 'flex',
                      alignItems: 'center',
                      justifyContent: 'center',
                      gap: 1
                    }}>
                      <InfoIcon sx={{ fontSize: 16 }} />
                      Click on an idle code to assign it to the selected employee{bulkEmployeeList.length > 1 ? 's' : ''}
                    </Typography>
                  </Box>

                  {/* Enhanced Idle Code Grid */}
                  <Box sx={{
                    display: 'grid',
                    gridTemplateColumns: 'repeat(auto-fit, minmax(120px, 1fr))',
                    gap: 2,
                    justifyItems: 'center'
                  }}>
                    {idleTimesData.map((item, index) => {
                      const isMealCode = ["IT-TT", "IT-LT", "IT-DT"].includes(item.code);

                      return (
                        <Box
                          key={item.code}

                        >
                          <Button
                            onClick={() => handleSecondDialogOpen(item)}
                            sx={{
                              width: 120,
                              height: 80,
                              display: 'flex',
                              flexDirection: 'column',
                              gap: 1,
                              borderRadius: 3,
                              border: '2px solid',
                              borderColor: isMealCode ? '#ff9800' : '#2196f3',
                              backgroundColor: isMealCode
                                ? 'linear-gradient(135deg, #fff3e0 0%, #ffe0b2 100%)'
                                : 'linear-gradient(135deg, #e3f2fd 0%, #bbdefb 100%)',
                              color: isMealCode ? '#ef6c00' : '#1565c0',
                              fontWeight: 700,
                              fontSize: '1rem',
                              position: 'relative',
                              overflow: 'hidden',
                              transition: 'all 0.3s cubic-bezier(0.4, 0, 0.2, 1)',

                              '&::before': {
                                content: '""',
                                position: 'absolute',
                                top: 0,
                                left: 0,
                                right: 0,
                                bottom: 0,
                                background: isMealCode
                                  ? 'linear-gradient(135deg, rgba(255,152,0,0.1) 0%, rgba(245,124,0,0.1) 100%)'
                                  : 'linear-gradient(135deg, rgba(33,150,243,0.1) 0%, rgba(25,118,210,0.1) 100%)',
                                opacity: 0,
                                transition: 'opacity 0.3s ease'
                              }
                            }}
                          >
                            {/* Icon based on code type */}
                            <Box sx={{ position: 'relative', zIndex: 1 }}>
                              {isMealCode ? (
                                <RestaurantIcon sx={{ fontSize: 24 }} />
                              ) : (
                                <PauseIcon sx={{ fontSize: 24 }} />
                              )}
                            </Box>

                            {/* Code */}
                            <Typography variant="h6" sx={{
                              fontWeight: 'bold',
                              position: 'relative',
                              zIndex: 1,
                              letterSpacing: '0.5px'
                            }}>
                              {item.code}
                            </Typography>

                            {/* Type indicator */}
                            <Box sx={{
                              position: 'absolute',
                              top: 4,
                              right: 4,
                              width: 8,
                              height: 8,
                              borderRadius: '50%',
                              backgroundColor: isMealCode ? '#ff9800' : '#2196f3',

                            }} />
                          </Button>

                          {/* Code Description */}
                          {item.process && (
                            <Typography variant="caption" sx={{
                              display: 'block',
                              textAlign: 'center',
                              mt: 1,
                              color: 'text.secondary',
                              fontWeight: 500,
                              maxWidth: 120,
                              overflow: 'hidden',
                              textOverflow: 'ellipsis',
                              whiteSpace: 'nowrap'
                            }}>
                              {item.process}
                            </Typography>
                          )}
                        </Box>
                      );
                    })}
                  </Box>

                  {/* Legend */}
                  <Box sx={{
                    display: 'flex',
                    justifyContent: 'center',
                    gap: 3,
                    mt: 3,
                    pt: 2,
                    borderTop: '1px solid rgba(0,0,0,0.1)'
                  }}>
                    <Box sx={{ display: 'flex', alignItems: 'center', gap: 0.5 }}>
                      <Box sx={{
                        width: 12,
                        height: 12,
                        borderRadius: '50%',
                        backgroundColor: '#2196f3'
                      }} />
                      <Typography variant="caption" sx={{ fontWeight: 500, color: 'text.secondary' }}>
                        General Idle
                      </Typography>
                    </Box>
                    <Box sx={{ display: 'flex', alignItems: 'center', gap: 0.5 }}>
                      <Box sx={{
                        width: 12,
                        height: 12,
                        borderRadius: '50%',
                        backgroundColor: '#ff9800',

                      }} />
                      <Typography variant="caption" sx={{ fontWeight: 500, color: 'text.secondary' }}>
                        Meal Times
                      </Typography>
                    </Box>
                  </Box>
                </>
              ) : (
                /* Enhanced Empty State */
                <Box sx={{
                  display: 'flex',
                  flexDirection: 'column',
                  alignItems: 'center',
                  justifyContent: 'center',
                  py: 6,
                  gap: 2
                }}>
                  <Box sx={{
                    p: 3,
                    borderRadius: '50%',
                    backgroundColor: 'rgba(158,158,158,0.1)',
                    border: '2px dashed rgba(158,158,158,0.3)'
                  }}>
                    <SearchOffIcon sx={{ fontSize: 48, color: 'text.secondary', opacity: 0.5 }} />
                  </Box>
                  <Typography variant="h6" sx={{ fontWeight: 500, color: 'text.secondary' }}>
                    No Idle Codes Available
                  </Typography>
                  <Typography variant="body2" sx={{
                    color: 'text.secondary',
                    textAlign: 'center',
                    maxWidth: 300
                  }}>
                    No idle time codes are configured for this machine or group. Please contact your administrator.
                  </Typography>
                </Box>
              )}
            </DialogContent>

            {/* Enhanced Dialog Actions */}
            <DialogActions sx={{
              px: 4,
              py: 3,
              backgroundColor: '#f8f9fa',
              borderTop: '1px solid rgba(0,0,0,0.1)',
              justifyContent: 'space-between'
            }}>
              {/* Info Section */}
              <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
                <Typography variant="caption" sx={{
                  color: 'text.secondary',
                  fontStyle: 'italic'
                }}>
                  {idleTimesData.length} code{idleTimesData.length !== 1 ? 's' : ''} available
                </Typography>
              </Box>

              {/* Action Buttons */}
              <Box sx={{ display: 'flex', gap: 1 }}>
                <Button
                  onClick={() => setOpen(false)}
                  variant="outlined"
                  sx={{
                    borderRadius: 2,
                    px: 3,
                    fontWeight: 600,
                    borderColor: '#e0e0e0',
                    color: 'text.secondary',

                  }}
                >
                  Cancel
                </Button>
              </Box>
            </DialogActions>
          </Dialog>



          <Dialog
            open={isSecondModalOpen}
            onClose={() => setIsSecondModalOpen(false)}
            maxWidth="sm"
            fullWidth
            PaperProps={{
              sx: {
                borderRadius: 2,
                boxShadow: '0 20px 25px -5px rgba(0, 0, 0, 0.1), 0 10px 10px -5px rgba(0, 0, 0, 0.04)'
              }
            }}
          >
            {/* Header */}
            <DialogTitle sx={{ pb: 2 }}>
              <Box display="flex" alignItems="center" gap={2}>
                <Box
                  sx={{
                    width: 40,
                    height: 40,
                    bgcolor: 'warning.light',
                    borderRadius: '50%',
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center'
                  }}
                >
                  <WarningIcon sx={{ color: 'warning.main' }} />
                </Box>
                <Box>
                  <Typography variant="h6" component="h2" fontWeight={600}>
                    Confirm Action
                  </Typography>
                  <Typography variant="body2" color="text.secondary">
                    This action cannot be undone
                  </Typography>
                </Box>
              </Box>
            </DialogTitle>

            {/* Content */}
            <DialogContent sx={{ pt: 0, pb: 2 }}>
              <Box mb={3}>
                <Box display="flex" alignItems="center" gap={1} mb={2}>
                  <Typography variant="body2" fontWeight={500}>
                    Idle Code:
                  </Typography>
                  <Chip
                    label={selectedJob?.code}
                    size="small"
                    color="primary"
                    sx={{ fontFamily: 'monospace' }}
                  />
                </Box>

                <Box display="flex" alignItems="center" gap={1} mb={2}>
                  <PeopleIcon sx={{ fontSize: 16, color: 'text.secondary' }} />
                  <Typography variant="body2" color="text.secondary">
                    <strong>{bulkEmployeeList.length}</strong> employees selected
                  </Typography>
                </Box>
              </Box>

              <Alert
                severity="info"
                sx={{
                  backgroundColor: 'primary.light',
                  color: 'primary.contrastText',
                  '& .MuiAlert-icon': {
                    color: 'primary.main'
                  }
                }}
              >
                {selectedJob?.process}
              </Alert>
            </DialogContent>

            {/* Actions */}
            <DialogActions sx={{ px: 3, pb: 3, gap: 1 }}>
              <Button
                onClick={() => setIsSecondModalOpen(false)}
                variant="outlined"
                color="inherit"
                sx={{
                  minWidth: 100,
                  textTransform: 'none',
                  fontWeight: 500
                }}
              >
                Cancel
              </Button>
              <Button
                onClick={handleProceed}
                disabled={isSubmitting}
                variant="contained"
                color="success"
                startIcon={isSubmitting ? <CircularProgress size={16} /> : <CheckIcon />}
                sx={{
                  minWidth: 120,
                  textTransform: 'none',
                  fontWeight: 500
                }}
              >
                {isSubmitting ? 'Processing...' : 'Confirm'}
              </Button>
            </DialogActions>
          </Dialog>



          <Dialog
            open={confirmRemoveOpen}
            onClose={handleConfirmRemoveClose}
            maxWidth="sm"
            fullWidth
            PaperProps={{
              sx: {
                borderRadius: 2,
                boxShadow: '0 20px 25px -5px rgba(0, 0, 0, 0.1), 0 10px 10px -5px rgba(0, 0, 0, 0.04)'
              }
            }}
          >
            {/* Header */}
            <DialogTitle sx={{ pb: 2 }}>
              <Box display="flex" alignItems="center" gap={2}>
                <Box
                  sx={{
                    width: 40,
                    height: 40,
                    bgcolor: 'warning.light',
                    borderRadius: '50%',
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center'
                  }}
                >
                  <PersonRemoveIcon sx={{ color: 'warning.main' }} />
                </Box>
                <Box>
                  <Typography variant="h6" component="h2" fontWeight={600}>
                    Remove Employee
                  </Typography>
                  <Typography variant="body2" color="text.secondary">
                    Confirm workstation removal
                  </Typography>
                </Box>
              </Box>
            </DialogTitle>

            {/* Content */}
            <DialogContent sx={{ pt: 0, pb: 2 }}>
              {/* Employee Info Card */}
              <Box
                sx={{
                  display: 'flex',
                  alignItems: 'center',
                  gap: 2,
                  p: 2,
                  bgcolor: 'grey.50',
                  borderRadius: 1,
                  border: '1px solid',
                  borderColor: 'grey.200',
                  mb: 2
                }}
              >
                <Avatar
                  sx={{
                    bgcolor: 'primary.main',
                    width: 48,
                    height: 48
                  }}
                >
                  <PersonIcon />
                </Avatar>
                <Box flex={1}>
                  <Typography variant="h6" fontWeight={600} color="text.primary">
                    {employeeToRemove?.empName}
                  </Typography>
                  <Box display="flex" alignItems="center" gap={1} mt={0.5}>
                    <Typography variant="body2" color="text.secondary">
                      Employee ID:
                    </Typography>
                    <Chip
                      label={employeeToRemove?.empId}
                      size="small"
                      variant="outlined"
                      sx={{ fontFamily: 'monospace', fontSize: '0.75rem' }}
                    />
                  </Box>
                </Box>
              </Box>

              {/* Warning Message */}
              <Alert
                severity="warning"
                icon={<WarningIcon />}
                sx={{
                  '& .MuiAlert-message': {
                    fontSize: '0.95rem'
                  }
                }}
              >
                This will remove the employee from the current workstation. They can be reassigned later if needed.
              </Alert>

              {/* Confirmation Question */}
              <Box sx={{ textAlign: 'center', mt: 2 }}>
                <Typography variant="body1" color="text.primary" fontWeight={500}>
                  Are you sure you want to proceed with the removal?
                </Typography>
              </Box>
            </DialogContent>

            {/* Actions */}
            <DialogActions sx={{ px: 3, pb: 3, gap: 1, justifyContent: 'center' }}>
              <Button
                onClick={handleConfirmRemoveClose}
                variant="outlined"
                color="inherit"
                startIcon={<CloseIcon />}
                sx={{
                  minWidth: 100,
                  textTransform: 'none',
                  fontWeight: 500
                }}
              >
                Cancel
              </Button>
              <Button
                onClick={handleRemoveConfirm}
                variant="contained"
                color="error"
                startIcon={<DeleteIcon />}
                sx={{
                  minWidth: 120,
                  textTransform: 'none',
                  fontWeight: 500
                }}
              >
                Remove
              </Button>
            </DialogActions>
          </Dialog>





          <Dialog
            open={productionConfirmOpen}
            onClose={() => setProductionConfirmOpen(false)}
            maxWidth="sm"
            fullWidth
            sx={{
              '& .MuiDialog-paper': {
                borderRadius: 4,
                boxShadow: '0 20px 40px rgba(0,0,0,0.15)',
                background: 'linear-gradient(145deg, #ffffff 0%, #f8f9fa 100%)',
                overflow: 'hidden'
              }
            }}
          >
            {/* Enhanced Dialog Title */}
            <DialogTitle sx={{
              background: 'linear-gradient(135deg, #e8f5e8 0%, #c8e6c9 100%)',
              color: '#2e7d32',
              textAlign: 'center',
              py: 4,
              borderBottom: '2px solid #e8f5e8'
            }}>
              <Box sx={{ display: 'flex', flexDirection: 'column', alignItems: 'center', gap: 2 }}>
                {/* Icon Header */}
                <Box sx={{
                  p: 2.5,
                  borderRadius: '50%',
                  backgroundColor: 'rgba(76,175,80,0.1)',
                  border: '3px solid rgba(76,175,80,0.2)',

                }}>
                  <PlayArrowIcon sx={{ fontSize: 36, color: '#4caf50' }} />
                </Box>

                {/* Title */}
                <Typography variant="h5" sx={{
                  fontWeight: 700,
                  mb: 0.5,
                  textShadow: '0 1px 2px rgba(0,0,0,0.1)'
                }}>
                  Confirm Production Start
                </Typography>

                {/* Subtitle */}
                <Typography variant="body2" sx={{
                  color: 'text.secondary',
                  fontWeight: 500,
                  opacity: 0.8
                }}>
                  Ready to begin production workflow
                </Typography>
              </Box>
            </DialogTitle>

            {/* Enhanced Dialog Content */}
            <DialogContent sx={{
              px: 4,
              py: 4,
              textAlign: 'center'
            }}>
              {/* Employee Information Card */}
              <Box sx={{
                p: 3,
                borderRadius: 3,
                backgroundColor: 'rgba(76,175,80,0.05)',
                border: '1px solid rgba(76,175,80,0.1)',
                mb: 3,
                position: 'relative',
                overflow: 'hidden',
                '&::before': {
                  content: '""',
                  position: 'absolute',
                  top: 0,
                  left: 0,
                  right: 0,
                  height: 4,
                  background: 'linear-gradient(90deg, #4caf50 0%, #66bb6a 100%)'
                }
              }}>
                <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'center', gap: 2, mb: 2 }}>
                  <Avatar sx={{
                    backgroundColor: '#4caf50',
                    width: 48,
                    height: 48,
                    fontSize: 20,
                    fontWeight: 'bold'
                  }}>
                    <PersonIcon />
                  </Avatar>
                  <Box sx={{ textAlign: 'left' }}>
                    <Typography variant="h6" sx={{ fontWeight: 600, color: '#2e7d32' }}>
                      {currentProductionEmployee?.empName || 'Employee Name'}
                    </Typography>
                    <Chip
                      label={`ID: ${currentProductionEmployee?.empId || 'N/A'}`}
                      size="small"
                      sx={{
                        backgroundColor: 'rgba(76,175,80,0.1)',
                        color: '#2e7d32',
                        fontWeight: 600,
                        fontSize: '0.75rem'
                      }}
                    />
                  </Box>
                </Box>
              </Box>

              {/* Confirmation Message */}
              <Box sx={{ mb: 3 }}>
                <Typography variant="body1" sx={{
                  color: 'text.primary',
                  fontWeight: 500,
                  lineHeight: 1.6,
                  mb: 2
                }}>
                  Are you sure you want to start production for this employee?
                </Typography>

                {/* Info Box */}
                <Box sx={{
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'center',
                  gap: 1,
                  p: 2,
                  backgroundColor: 'rgba(255,193,7,0.1)',
                  borderRadius: 2,
                  border: '1px solid rgba(255,193,7,0.2)'
                }}>
                  <WarningIcon sx={{ fontSize: 18, color: '#ff9800' }} />
                  <Typography variant="caption" sx={{
                    color: 'text.secondary',
                    fontWeight: 500
                  }}>
                    This action will begin the production workflow immediately
                  </Typography>
                </Box>
              </Box>

              {/* Action Preview */}
              <Box sx={{
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                gap: 2,
                p: 2,
                backgroundColor: 'rgba(33,150,243,0.05)',
                borderRadius: 2,
                border: '1px dashed rgba(33,150,243,0.2)'
              }}>
                <CheckCircleIcon sx={{ fontSize: 20, color: '#2196f3' }} />
                <Typography variant="body2" sx={{
                  color: '#1976d2',
                  fontWeight: 500
                }}>
                  Production tracking will begin for this employee
                </Typography>
              </Box>
            </DialogContent>

            {/* Enhanced Dialog Actions */}
            <DialogActions sx={{
              px: 4,
              py: 3,
              backgroundColor: '#f8f9fa',
              borderTop: '1px solid rgba(0,0,0,0.1)',
              gap: 2,
              justifyContent: 'center'
            }}>
              {/* Primary Action */}
              <Button
                onClick={handleProductionConfirm}
                variant="contained"
                sx={{
                  px: 4,
                  py: 1.5,
                  borderRadius: 3,
                  fontWeight: 700,
                  fontSize: '0.95rem',
                  background: 'linear-gradient(135deg, #4caf50 0%, #66bb6a 100%)',
                  boxShadow: '0 4px 12px rgba(76,175,80,0.3)',
                  textTransform: 'none',
                  minWidth: 180,


                }}
                startIcon={<PlayArrowIcon />}
              >
                Yes, Start Production
              </Button>

              {/* Secondary Action */}
              <Button
                onClick={() => setProductionConfirmOpen(false)}
                variant="outlined"
                sx={{
                  px: 4,
                  py: 1.5,
                  borderRadius: 3,
                  fontWeight: 600,
                  fontSize: '0.95rem',
                  borderColor: '#e0e0e0',
                  color: 'text.secondary',
                  textTransform: 'none',
                  minWidth: 120,


                }}
              >
                Cancel
              </Button>
            </DialogActions>
          </Dialog>




          <Dialog
            open={openIdleCodesDialog}
            onClose={handleCloseIdleCodesDialog}
            fullWidth
            maxWidth="md"
            sx={{
              '& .MuiDialog-paper': {
                borderRadius: 3,
                boxShadow: '0 24px 48px rgba(0,0,0,0.15)',
                background: 'linear-gradient(145deg, #ffffff 0%, #f8f9fa 100%)',
                overflow: 'hidden'
              }
            }}
          >
            {/* Enhanced Dialog Title */}
            <DialogTitle sx={{
              background: 'linear-gradient(135deg, #e3f2fd 0%, #bbdefb 100%)',
              color: '#1565c0',
              textAlign: 'center',
              py: 3,
              borderBottom: '2px solid #e3f2fd'
            }}>
              <Box sx={{ display: 'flex', flexDirection: 'column', alignItems: 'center', gap: 1 }}>
                {/* Icon Header */}
                <Box sx={{
                  p: 2,
                  borderRadius: '50%',
                  backgroundColor: 'rgba(33,150,243,0.1)',
                  border: '2px solid rgba(33,150,243,0.2)'
                }}>
                  <PauseCircleOutlineIcon sx={{ fontSize: 32, color: '#2196f3' }} />
                </Box>

                {/* Title */}
                <Typography variant="h5" sx={{ fontWeight: 600, mb: 0.5 }}>
                  Select Idle Code
                </Typography>

                {/* Subtitle */}
                <Typography variant="body2" sx={{
                  color: 'text.secondary',
                  fontWeight: 500,
                  display: 'flex',
                  alignItems: 'center',
                  gap: 0.5
                }}>
                  <GroupsIcon sx={{ fontSize: 16 }} />
                  {bulkJobEmployeeList.length > 0
                    ? `${bulkJobEmployeeList.length} Selected Employee${bulkJobEmployeeList.length > 1 ? 's' : ''}`
                    : `${currentEmployee?.emp_name || "Employee"} (ID: ${currentEmployee?.emp_id})`
                  }
                </Typography>

                {/* Employee Names for Bulk Selection */}
                {bulkJobEmployeeList.length > 0 && bulkJobEmployeeList.length <= 5 && (
                  <Box sx={{
                    display: 'flex',
                    gap: 0.5,
                    flexWrap: 'wrap',
                    justifyContent: 'center',
                    mt: 1
                  }}>
                    {bulkJobEmployeeList.map((emp, index) => (
                      <Chip
                        key={emp.emp_id}
                        label={emp.emp_name || `ID: ${emp.emp_id}`}
                        size="small"
                        sx={{
                          backgroundColor: 'rgba(33,150,243,0.1)',
                          color: '#2196f3',
                          fontWeight: 500,
                          fontSize: '0.7rem'
                        }}
                      />
                    ))}
                  </Box>
                )}

                {/* Show count if more than 5 employees */}
                {bulkJobEmployeeList.length > 5 && (
                  <Chip
                    label={`${bulkJobEmployeeList.length} employees selected`}
                    sx={{
                      backgroundColor: '#2196f3',
                      color: 'white',
                      fontWeight: 600,
                      mt: 1
                    }}
                  />
                )}
              </Box>
            </DialogTitle>

            {/* Enhanced Dialog Content */}
            <DialogContent sx={{
              px: 4,
              py: 3,
              minHeight: 200,
              display: 'flex',
              flexDirection: 'column'
            }}>
              {/* Loading State */}
              {loading && (
                <Box sx={{
                  display: 'flex',
                  justifyContent: 'center',
                  alignItems: 'center',
                  py: 6
                }}>
                  <CircularProgress size={48} sx={{ color: '#2196f3' }} />
                </Box>
              )}

              {/* Error State */}
              {!loading && error && (
                <Box sx={{
                  display: 'flex',
                  flexDirection: 'column',
                  alignItems: 'center',
                  justifyContent: 'center',
                  py: 6,
                  gap: 2
                }}>
                  <Typography variant="h6" sx={{ fontWeight: 500, color: 'error.main' }}>
                    Error Loading Idle Codes
                  </Typography>
                  <Typography variant="body2" sx={{
                    color: 'text.secondary',
                    textAlign: 'center',
                    maxWidth: 300
                  }}>
                    {error}
                  </Typography>
                </Box>
              )}

              {/* Success State with Idle Codes */}
              {!loading && !error && idleCodesData.length > 0 && (
                <>
                  {/* Instructions */}
                  <Box sx={{
                    mb: 3,
                    p: 2,
                    backgroundColor: 'rgba(33,150,243,0.05)',
                    borderRadius: 2,
                    border: '1px solid rgba(33,150,243,0.1)'
                  }}>
                    <Typography variant="body2" sx={{
                      color: 'text.secondary',
                      textAlign: 'center',
                      fontStyle: 'italic',
                      display: 'flex',
                      alignItems: 'center',
                      justifyContent: 'center',
                      gap: 1
                    }}>
                      <InfoIcon sx={{ fontSize: 16 }} />
                      Click on an idle code to assign it to the selected employee{bulkJobEmployeeList.length > 1 ? 's' : ''}
                    </Typography>
                  </Box>

                  {/* Enhanced Idle Code Grid */}
                  <Box sx={{
                    display: 'grid',
                    gridTemplateColumns: 'repeat(auto-fit, minmax(120px, 1fr))',
                    gap: 2,
                    justifyItems: 'center'
                  }}>
                    {idleCodesData.map((codeItem, index) => {
                      const isMealCode = ["IT-TT", "IT-LT", "IT-DT"].includes(codeItem.code);

                      return (
                        <Box
                          key={codeItem.code}

                        >
                          <Button
                            onClick={() => handleJobIdleCodeClick(codeItem)}
                            sx={{
                              width: 120,
                              height: 80,
                              display: 'flex',
                              flexDirection: 'column',
                              gap: 1,
                              borderRadius: 3,
                              border: '2px solid',
                              borderColor: isMealCode ? '#ff9800' : '#2196f3',
                              backgroundColor: isMealCode
                                ? 'linear-gradient(135deg, #fff3e0 0%, #ffe0b2 100%)'
                                : 'linear-gradient(135deg, #e3f2fd 0%, #bbdefb 100%)',
                              color: isMealCode ? '#ef6c00' : '#1565c0',
                              fontWeight: 700,
                              fontSize: '1rem',
                              position: 'relative',
                              overflow: 'hidden',
                              transition: 'all 0.3s cubic-bezier(0.4, 0, 0.2, 1)',


                              '&::before': {
                                content: '""',
                                position: 'absolute',
                                top: 0,
                                left: 0,
                                right: 0,
                                bottom: 0,
                                background: isMealCode
                                  ? 'linear-gradient(135deg, rgba(255,152,0,0.1) 0%, rgba(245,124,0,0.1) 100%)'
                                  : 'linear-gradient(135deg, rgba(33,150,243,0.1) 0%, rgba(25,118,210,0.1) 100%)',
                                opacity: 0,
                                transition: 'opacity 0.3s ease'
                              }
                            }}
                          >
                            {/* Icon based on code type */}
                            <Box sx={{ position: 'relative', zIndex: 1 }}>
                              {isMealCode ? (
                                <RestaurantIcon sx={{ fontSize: 24 }} />
                              ) : (
                                <PauseIcon sx={{ fontSize: 24 }} />
                              )}
                            </Box>

                            {/* Code */}
                            <Typography variant="h6" sx={{
                              fontWeight: 'bold',
                              position: 'relative',
                              zIndex: 1,
                              letterSpacing: '0.5px'
                            }}>
                              {codeItem.code}
                            </Typography>

                            {/* Type indicator */}
                            <Box sx={{
                              position: 'absolute',
                              top: 4,
                              right: 4,
                              width: 8,
                              height: 8,
                              borderRadius: '50%',
                              backgroundColor: isMealCode ? '#ff9800' : '#2196f3',

                            }} />
                          </Button>

                          {/* Code Description */}
                          {codeItem.process && (
                            <Typography variant="caption" sx={{
                              display: 'block',
                              textAlign: 'center',
                              mt: 1,
                              color: 'text.secondary',
                              fontWeight: 500,
                              maxWidth: 120,
                              overflow: 'hidden',
                              textOverflow: 'ellipsis',
                              whiteSpace: 'nowrap'
                            }}>
                              {codeItem.process}
                            </Typography>
                          )}
                        </Box>
                      );
                    })}
                  </Box>

                  {/* Legend */}
                  <Box sx={{
                    display: 'flex',
                    justifyContent: 'center',
                    gap: 3,
                    mt: 3,
                    pt: 2,
                    borderTop: '1px solid rgba(0,0,0,0.1)'
                  }}>
                    <Box sx={{ display: 'flex', alignItems: 'center', gap: 0.5 }}>
                      <Box sx={{
                        width: 12,
                        height: 12,
                        borderRadius: '50%',
                        backgroundColor: '#2196f3'
                      }} />
                      <Typography variant="caption" sx={{ fontWeight: 500, color: 'text.secondary' }}>
                        General Idle
                      </Typography>
                    </Box>
                    <Box sx={{ display: 'flex', alignItems: 'center', gap: 0.5 }}>
                      <Box sx={{
                        width: 12,
                        height: 12,
                        borderRadius: '50%',
                        backgroundColor: '#ff9800',

                      }} />
                      <Typography variant="caption" sx={{ fontWeight: 500, color: 'text.secondary' }}>
                        Meal Times
                      </Typography>
                    </Box>
                  </Box>
                </>
              )}

              {/* Empty State */}
              {!loading && !error && idleCodesData.length === 0 && (
                <Box sx={{
                  display: 'flex',
                  flexDirection: 'column',
                  alignItems: 'center',
                  justifyContent: 'center',
                  py: 6,
                  gap: 2
                }}>
                  <Box sx={{
                    p: 3,
                    borderRadius: '50%',
                    backgroundColor: 'rgba(158,158,158,0.1)',
                    border: '2px dashed rgba(158,158,158,0.3)'
                  }}>
                    <SearchOffIcon sx={{ fontSize: 48, color: 'text.secondary', opacity: 0.5 }} />
                  </Box>
                  <Typography variant="h6" sx={{ fontWeight: 500, color: 'text.secondary' }}>
                    No Idle Codes Available
                  </Typography>
                  <Typography variant="body2" sx={{
                    color: 'text.secondary',
                    textAlign: 'center',
                    maxWidth: 300
                  }}>
                    No idle time codes are configured for this machine or group. Please contact your administrator.
                  </Typography>
                </Box>
              )}
            </DialogContent>

            {/* Enhanced Dialog Actions */}
            <DialogActions sx={{
              px: 4,
              py: 3,
              backgroundColor: '#f8f9fa',
              borderTop: '1px solid rgba(0,0,0,0.1)',
              justifyContent: 'space-between'
            }}>
              {/* Info Section */}
              <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
                <Typography variant="caption" sx={{
                  color: 'text.secondary',
                  fontStyle: 'italic'
                }}>
                  {loading ? 'Loading...' : `${idleCodesData.length} code${idleCodesData.length !== 1 ? 's' : ''} available`}
                </Typography>
              </Box>

              {/* Action Buttons */}
              <Box sx={{ display: 'flex', gap: 1 }}>
                <Button
                  onClick={handleCloseIdleCodesDialog}
                  variant="outlined"
                  sx={{
                    borderRadius: 2,
                    px: 3,
                    fontWeight: 600,
                    borderColor: '#e0e0e0',
                    color: 'text.secondary',

                  }}
                >
                  Cancel
                </Button>
              </Box>
            </DialogActions>
          </Dialog>

          <Dialog
            open={confirmjobIdleStartOpen}
            onClose={() => setConfirmjobIdleStartOpen(false)}
            maxWidth="md"
            fullWidth
            sx={{
              '& .MuiDialog-paper': {
                borderRadius: 4,
                boxShadow: '0 20px 40px rgba(0,0,0,0.15)',
                background: 'linear-gradient(145deg, #ffffff 0%, #f8f9fa 100%)',
                overflow: 'hidden'
              }
            }}
          >
            {/* Enhanced Dialog Title */}
            <DialogTitle sx={{
              background: selectedCodeItem?.code && ["IT-TT", "IT-LT", "IT-DT"].includes(selectedCodeItem.code)
                ? 'linear-gradient(135deg, #fff3e0 0%, #ffe0b2 100%)'
                : 'linear-gradient(135deg, #e3f2fd 0%, #bbdefb 100%)',
              color: selectedCodeItem?.code && ["IT-TT", "IT-LT", "IT-DT"].includes(selectedCodeItem.code)
                ? '#ef6c00'
                : '#1565c0',
              textAlign: 'center',
              py: 4,
              borderBottom: selectedCodeItem?.code && ["IT-TT", "IT-LT", "IT-DT"].includes(selectedCodeItem.code)
                ? '2px solid #ffe0b2'
                : '2px solid #e3f2fd'
            }}>
              <Box sx={{ display: 'flex', flexDirection: 'column', alignItems: 'center', gap: 2 }}>
                {/* Icon Header */}
                <Box sx={{
                  p: 2.5,
                  borderRadius: '50%',
                  backgroundColor: selectedCodeItem?.code && ["IT-TT", "IT-LT", "IT-DT"].includes(selectedCodeItem.code)
                    ? 'rgba(255,152,0,0.1)'
                    : 'rgba(33,150,243,0.1)',
                  border: selectedCodeItem?.code && ["IT-TT", "IT-LT", "IT-DT"].includes(selectedCodeItem.code)
                    ? '3px solid rgba(255,152,0,0.2)'
                    : '3px solid rgba(33,150,243,0.2)',

                }}>
                  {selectedCodeItem?.code && ["IT-TT", "IT-LT", "IT-DT"].includes(selectedCodeItem.code) ? (
                    <RestaurantIcon sx={{ fontSize: 36, color: '#ff9800' }} />
                  ) : (
                    <PauseCircleOutlineIcon sx={{ fontSize: 36, color: '#2196f3' }} />
                  )}
                </Box>

                {/* Title */}
                <Typography variant="h5" sx={{
                  fontWeight: 700,
                  mb: 0.5,
                  textShadow: '0 1px 2px rgba(0,0,0,0.1)'
                }}>
                  Confirm Idle Operation Start
                </Typography>

                {/* Subtitle */}
                <Typography variant="body2" sx={{
                  color: 'text.secondary',
                  fontWeight: 500,
                  opacity: 0.8
                }}>
                  Ready to begin idle time tracking
                </Typography>
              </Box>
            </DialogTitle>

            {/* Enhanced Dialog Content */}
            <DialogContent sx={{
              px: 4,
              py: 4
            }}>
              {/* Idle Code Information */}
              <Box sx={{
                p: 3,
                borderRadius: 3,
                backgroundColor: selectedCodeItem?.code && ["IT-TT", "IT-LT", "IT-DT"].includes(selectedCodeItem.code)
                  ? 'rgba(255,152,0,0.05)'
                  : 'rgba(33,150,243,0.05)',
                border: selectedCodeItem?.code && ["IT-TT", "IT-LT", "IT-DT"].includes(selectedCodeItem.code)
                  ? '1px solid rgba(255,152,0,0.1)'
                  : '1px solid rgba(33,150,243,0.1)',
                mb: 3,
                position: 'relative',
                overflow: 'hidden',
                '&::before': {
                  content: '""',
                  position: 'absolute',
                  top: 0,
                  left: 0,
                  right: 0,
                  height: 4,
                  background: selectedCodeItem?.code && ["IT-TT", "IT-LT", "IT-DT"].includes(selectedCodeItem.code)
                    ? 'linear-gradient(90deg, #ff9800 0%, #ffb74d 100%)'
                    : 'linear-gradient(90deg, #2196f3 0%, #42a5f5 100%)'
                }
              }}>
                <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'center', gap: 2, mb: 2 }}>
                  <Box sx={{
                    p: 1.5,
                    borderRadius: 2,
                    backgroundColor: selectedCodeItem?.code && ["IT-TT", "IT-LT", "IT-DT"].includes(selectedCodeItem.code)
                      ? 'rgba(255,152,0,0.1)'
                      : 'rgba(33,150,243,0.1)'
                  }}>
                    {selectedCodeItem?.code && ["IT-TT", "IT-LT", "IT-DT"].includes(selectedCodeItem.code) ? (
                      <RestaurantIcon sx={{ fontSize: 24, color: '#ff9800' }} />
                    ) : (
                      <PauseIcon sx={{ fontSize: 24, color: '#2196f3' }} />
                    )}
                  </Box>
                  <Box sx={{ textAlign: 'left' }}>
                    <Typography variant="h6" sx={{
                      fontWeight: 600,
                      color: selectedCodeItem?.code && ["IT-TT", "IT-LT", "IT-DT"].includes(selectedCodeItem.code)
                        ? '#ef6c00'
                        : '#1565c0'
                    }}>
                      {selectedCodeItem?.code || 'N/A'}
                    </Typography>
                    <Chip
                      label={selectedCodeItem?.code && ["IT-TT", "IT-LT", "IT-DT"].includes(selectedCodeItem.code)
                        ? 'Meal Time'
                        : 'Idle Time'
                      }
                      size="small"
                      sx={{
                        backgroundColor: selectedCodeItem?.code && ["IT-TT", "IT-LT", "IT-DT"].includes(selectedCodeItem.code)
                          ? 'rgba(255,152,0,0.1)'
                          : 'rgba(33,150,243,0.1)',
                        color: selectedCodeItem?.code && ["IT-TT", "IT-LT", "IT-DT"].includes(selectedCodeItem.code)
                          ? '#ef6c00'
                          : '#1565c0',
                        fontWeight: 600,
                        fontSize: '0.75rem'
                      }}
                    />
                  </Box>
                </Box>
              </Box>

              {/* Confirmation Message */}
              <Box sx={{ mb: 3, textAlign: 'center' }}>
                <Typography variant="body1" sx={{
                  color: 'text.primary',
                  fontWeight: 500,
                  lineHeight: 1.6,
                  mb: 2
                }}>
                  {bulkJobEmployeeList.length > 0 ? (
                    <>
                      Are you sure you want to start <strong>{selectedCodeItem?.code}</strong> operation for{' '}
                      <strong>{bulkJobEmployeeList.length} selected employee{bulkJobEmployeeList.length > 1 ? 's' : ''}</strong>?
                    </>
                  ) : (
                    <>
                      Are you sure you want to start <strong>{selectedCodeItem?.code}</strong> operation for{' '}
                      <strong>{currentEmployee?.emp_name}</strong>?
                    </>
                  )}
                </Typography>
              </Box>

              {/* Employee List */}
              {bulkJobEmployeeList.length > 0 ? (
                <Box sx={{
                  backgroundColor: '#f8f9fa',
                  borderRadius: 3,
                  border: '1px solid rgba(0,0,0,0.1)',
                  mb: 3,
                  maxHeight: 300,
                  overflow: 'auto'
                }}>
                  <Box sx={{
                    p: 2,
                    backgroundColor: 'rgba(0,0,0,0.02)',
                    borderBottom: '1px solid rgba(0,0,0,0.1)',
                    display: 'flex',
                    alignItems: 'center',
                    gap: 1
                  }}>
                    <GroupsIcon sx={{ fontSize: 18, color: 'text.secondary' }} />
                    <Typography variant="subtitle2" sx={{ fontWeight: 600, color: 'text.primary' }}>
                      Selected Employees ({bulkJobEmployeeList.length})
                    </Typography>
                  </Box>
                  <List dense sx={{ py: 0 }}>
                    {bulkJobEmployeeList.map((emp, index) => (
                      <Box key={emp.emp_id}>
                        <ListItem sx={{ py: 1.5 }}>
                          <ListItemAvatar>
                            <Avatar sx={{
                              width: 32,
                              height: 32,
                              backgroundColor: '#2196f3',
                              fontSize: '0.875rem'
                            }}>
                              <PersonIcon sx={{ fontSize: 18 }} />
                            </Avatar>
                          </ListItemAvatar>
                          <ListItemText
                            primary={
                              <Typography variant="body2" sx={{ fontWeight: 500 }}>
                                {emp.emp_name}
                              </Typography>
                            }
                            secondary={
                              <Typography variant="caption" sx={{ color: 'text.secondary' }}>
                                ID: {emp.emp_id}
                              </Typography>
                            }
                          />
                        </ListItem>
                        {index < bulkJobEmployeeList.length - 1 && (
                          <Divider variant="inset" component="li" />
                        )}
                      </Box>
                    ))}
                  </List>
                </Box>
              ) : (
                /* Single Employee Card */
                <Box sx={{
                  p: 3,
                  borderRadius: 3,
                  backgroundColor: 'rgba(33,150,243,0.05)',
                  border: '1px solid rgba(33,150,243,0.1)',
                  mb: 3,
                  display: 'flex',
                  alignItems: 'center',
                  gap: 2
                }}>
                  <Avatar sx={{
                    backgroundColor: '#2196f3',
                    width: 48,
                    height: 48,
                    fontSize: 20,
                    fontWeight: 'bold'
                  }}>
                    <PersonIcon />
                  </Avatar>
                  <Box sx={{ flex: 1 }}>
                    <Typography variant="h6" sx={{ fontWeight: 600, color: '#1565c0' }}>
                      {currentEmployee?.emp_name || 'Employee Name'}
                    </Typography>
                    <Chip
                      label={`ID: ${currentEmployee?.emp_id || 'N/A'}`}
                      size="small"
                      sx={{
                        backgroundColor: 'rgba(33,150,243,0.1)',
                        color: '#1565c0',
                        fontWeight: 600,
                        fontSize: '0.75rem'
                      }}
                    />
                  </Box>
                </Box>
              )}

              {/* Info Box */}
              <Box sx={{
                display: 'flex',
                alignItems: 'center',
                gap: 2,
                p: 2.5,
                backgroundColor: 'rgba(255,193,7,0.1)',
                borderRadius: 2,
                border: '1px solid rgba(255,193,7,0.2)'
              }}>
                <WarningIcon sx={{ fontSize: 20, color: '#ff9800' }} />
                <Typography variant="body2" sx={{
                  color: 'text.secondary',
                  fontWeight: 500,
                  flex: 1
                }}>
                  This action will start idle time tracking for the selected employee{bulkJobEmployeeList.length > 1 ? 's' : ''}
                </Typography>
                <ScheduleIcon sx={{ fontSize: 18, color: '#ff9800' }} />
              </Box>
            </DialogContent>

            {/* Enhanced Dialog Actions */}
            <DialogActions sx={{
              px: 4,
              py: 3,
              backgroundColor: '#f8f9fa',
              borderTop: '1px solid rgba(0,0,0,0.1)',
              gap: 2,
              justifyContent: 'center'
            }}>
              {/* Primary Action */}
              <Button
                onClick={handleConfirmJobIdleStart}
                variant="contained"
                sx={{
                  px: 4,
                  py: 1.5,
                  borderRadius: 3,
                  fontWeight: 700,
                  fontSize: '0.95rem',
                  background: selectedCodeItem?.code && ["IT-TT", "IT-LT", "IT-DT"].includes(selectedCodeItem.code)
                    ? 'linear-gradient(135deg, #ff9800 0%, #ffb74d 100%)'
                    : 'linear-gradient(135deg, #2196f3 0%, #42a5f5 100%)',
                  boxShadow: selectedCodeItem?.code && ["IT-TT", "IT-LT", "IT-DT"].includes(selectedCodeItem.code)
                    ? '0 4px 12px rgba(255,152,0,0.3)'
                    : '0 4px 12px rgba(33,150,243,0.3)',
                  textTransform: 'none',
                  minWidth: 160,

                }}
                startIcon={selectedCodeItem?.code && ["IT-TT", "IT-LT", "IT-DT"].includes(selectedCodeItem.code)
                  ? <RestaurantIcon />
                  : <PauseIcon />
                }
              >
                Yes, Start Idle
              </Button>

              {/* Secondary Action */}
              <Button
                onClick={() => setConfirmjobIdleStartOpen(false)}
                variant="outlined"
                sx={{
                  px: 4,
                  py: 1.5,
                  borderRadius: 3,
                  fontWeight: 600,
                  fontSize: '0.95rem',
                  borderColor: '#e0e0e0',
                  color: 'text.secondary',
                  textTransform: 'none',
                  minWidth: 120,

                }}
              >
                Cancel
              </Button>
            </DialogActions>
          </Dialog>




          <Dialog
            open={confirmEndOpen}
            onClose={handleCloseEndConfirmDialog}
            maxWidth="xs"
            fullWidth
            sx={{
              '& .MuiDialog-paper': {
                borderRadius: 3,
                boxShadow: '0 16px 32px rgba(0,0,0,0.15)',
                background: 'linear-gradient(145deg, #ffffff 0%, #f8f9fa 100%)',
                overflow: 'hidden'
              }
            }}
          >
            {/* Compact Header */}
            <DialogTitle sx={{
              background: currentEndAction === 'production'
                ? 'linear-gradient(135deg, #ffebee 0%, #ffcdd2 100%)'
                : 'linear-gradient(135deg, #fff3e0 0%, #ffe0b2 100%)',
              color: currentEndAction === 'production' ? '#c62828' : '#ef6c00',
              textAlign: 'center',
              py: 2.5,
              borderBottom: currentEndAction === 'production'
                ? '2px solid #ffcdd2'
                : '2px solid #ffe0b2'
            }}>
              <Box sx={{ display: 'flex', flexDirection: 'column', alignItems: 'center', gap: 1 }}>
                {/* Icon */}
                <Box sx={{
                  p: 1.5,
                  borderRadius: '50%',
                  backgroundColor: currentEndAction === 'production'
                    ? 'rgba(244,67,54,0.1)'
                    : 'rgba(255,152,0,0.1)',
                  border: currentEndAction === 'production'
                    ? '2px solid rgba(244,67,54,0.2)'
                    : '2px solid rgba(255,152,0,0.2)'
                }}>
                  <StopIcon sx={{
                    fontSize: 24,
                    color: currentEndAction === 'production' ? '#f44336' : '#ff9800'
                  }} />
                </Box>

                {/* Title */}
                <Typography variant="h6" sx={{ fontWeight: 600, mb: 0 }}>
                  End {currentEndAction === 'production' ? 'Production' : 'Idle'}
                </Typography>
              </Box>
            </DialogTitle>

            {/* Compact Content */}
            <DialogContent sx={{ px: 3, py: 2.5 }}>
              {/* Employee Card */}
              <Box sx={{
                display: 'flex',
                alignItems: 'center',
                gap: 2,
                p: 2,
                borderRadius: 2,
                backgroundColor: 'rgba(33,150,243,0.05)',
                border: '1px solid rgba(33,150,243,0.1)',
                mb: 2
              }}>
                <Avatar sx={{
                  backgroundColor: '#2196f3',
                  width: 40,
                  height: 40
                }}>
                  <PersonIcon sx={{ fontSize: 20 }} />
                </Avatar>
                <Box sx={{ flex: 1 }}>
                  <Typography variant="body1" sx={{ fontWeight: 600, mb: 0.5 }}>
                    {currentEndEmployee?.emp_name || 'Employee'}
                  </Typography>
                  <Chip
                    label={`ID: ${currentEndEmployee?.emp_id || 'N/A'}`}
                    size="small"
                    sx={{
                      backgroundColor: 'rgba(33,150,243,0.1)',
                      color: '#1565c0',
                      fontSize: '0.7rem',
                      height: 20
                    }}
                  />
                </Box>
                <Box sx={{
                  p: 1,
                  borderRadius: 1,
                  backgroundColor: currentEndAction === 'production'
                    ? 'rgba(244,67,54,0.1)'
                    : 'rgba(255,152,0,0.1)'
                }}>
                  {currentEndAction === 'production' ? (
                    <FactoryIcon sx={{ fontSize: 18, color: '#f44336' }} />
                  ) : (
                    <PauseCircleOutlineIcon sx={{ fontSize: 18, color: '#ff9800' }} />
                  )}
                </Box>
              </Box>

              {/* Simple Message */}
              <Typography variant="body2" sx={{
                textAlign: 'center',
                color: 'text.secondary',
                fontWeight: 500
              }}>
                This will stop the current operation
              </Typography>
            </DialogContent>

            {/* Compact Actions */}
            <DialogActions sx={{
              px: 3,
              py: 2,
              backgroundColor: '#f8f9fa',
              borderTop: '1px solid rgba(0,0,0,0.1)',
              gap: 1.5,
              justifyContent: 'center'
            }}>
              <Button
                onClick={handleConfirmEndAction}
                variant="contained"
                sx={{
                  px: 3,
                  py: 1,
                  borderRadius: 2,
                  fontWeight: 600,
                  background: currentEndAction === 'production'
                    ? 'linear-gradient(135deg, #f44336 0%, #ef5350 100%)'
                    : 'linear-gradient(135deg, #ff9800 0%, #ffb74d 100%)',
                  boxShadow: currentEndAction === 'production'
                    ? '0 3px 8px rgba(244,67,54,0.3)'
                    : '0 3px 8px rgba(255,152,0,0.3)',
                  textTransform: 'none',
                  minWidth: 100,

                }}
                startIcon={<StopIcon sx={{ fontSize: 16 }} />}
              >
                End
              </Button>

              <Button
                onClick={handleCloseEndConfirmDialog}
                variant="outlined"
                sx={{
                  px: 3,
                  py: 1,
                  borderRadius: 2,
                  fontWeight: 500,
                  borderColor: '#e0e0e0',
                  color: 'text.secondary',
                  textTransform: 'none',
                  minWidth: 80,

                }}
              >
                Cancel
              </Button>
            </DialogActions>
          </Dialog>




          <Dialog
            open={endJobConfirmOpen}
            onClose={handleEndJobConfirmClose}
            maxWidth="sm"
            fullWidth
            PaperProps={{
              sx: {
                borderRadius: 2,
                boxShadow: '0 20px 25px -5px rgba(0, 0, 0, 0.1), 0 10px 10px -5px rgba(0, 0, 0, 0.04)'
              }
            }}
          >
            {/* Header */}
            <DialogTitle sx={{ pb: 2 }}>
              <Box display="flex" alignItems="center" gap={2}>
                <Box
                  sx={{
                    width: 40,
                    height: 40,
                    bgcolor: 'error.light',
                    borderRadius: '50%',
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center'
                  }}
                >
                  <WorkOffIcon sx={{ color: 'error.main' }} />
                </Box>
                <Box>
                  <Typography variant="h6" component="h2" fontWeight={600}>
                    End Job Assignment
                  </Typography>
                  <Typography variant="body2" color="text.secondary">
                    Confirm job termination
                  </Typography>
                </Box>
              </Box>
            </DialogTitle>

            {/* Content */}
            <DialogContent sx={{ pt: 0, pb: 2 }}>
              {/* Employee Info Card */}
              <Box
                sx={{
                  display: 'flex',
                  alignItems: 'center',
                  gap: 2,
                  p: 2,
                  bgcolor: 'grey.50',
                  borderRadius: 1,
                  border: '1px solid',
                  borderColor: 'grey.200',
                  mb: 2
                }}
              >
                <Avatar
                  sx={{
                    bgcolor: 'primary.main',
                    width: 48,
                    height: 48
                  }}
                >
                  <PersonIcon />
                </Avatar>
                <Box flex={1}>
                  <Typography variant="h6" fontWeight={600} color="text.primary">
                    {selectedEmployee?.emp_name}
                  </Typography>
                  <Box display="flex" alignItems="center" gap={1} mt={0.5}>
                    <Typography variant="body2" color="text.secondary">
                      Employee ID:
                    </Typography>
                    <Chip
                      label={selectedEmployee?.emp_id || 'N/A'}
                      size="small"
                      variant="outlined"
                      sx={{ fontFamily: 'monospace', fontSize: '0.75rem' }}
                    />
                  </Box>
                  {selectedEmployee?.current_job && (
                    <Box display="flex" alignItems="center" gap={1} mt={0.5}>
                      <TimeIcon sx={{ fontSize: 14, color: 'text.secondary' }} />
                      <Typography variant="body2" color="text.secondary">
                        Current Job: {selectedEmployee.current_job}
                      </Typography>
                    </Box>
                  )}
                </Box>
              </Box>

              {/* Warning Message */}


              <Divider sx={{ my: 2 }} />

              {/* Confirmation Question */}
              <Box sx={{ textAlign: 'center' }}>
                <Typography variant="body1" color="text.primary" fontWeight={500}>
                  Are you sure you want to end the job assignment for this employee?
                </Typography>
                <Typography variant="body2" color="text.secondary" sx={{ mt: 1 }}>
                  This action cannot be undone.
                </Typography>
              </Box>
            </DialogContent>

            {/* Actions */}
            <DialogActions sx={{ px: 3, pb: 3, gap: 1, justifyContent: 'center' }}>
              <Button
                onClick={handleEndJobConfirmClose}
                variant="outlined"
                color="inherit"
                startIcon={<CloseIcon />}
                sx={{
                  minWidth: 100,
                  textTransform: 'none',
                  fontWeight: 500
                }}
              >
                Cancel
              </Button>
              <Button
                onClick={handleConfirmEndJob}
                variant="contained"
                color="error"
                startIcon={<CheckIcon />}
                sx={{
                  minWidth: 120,
                  textTransform: 'none',
                  fontWeight: 500
                }}
              >
                End Job.
              </Button>
            </DialogActions>
          </Dialog>



          <Dialog open={jobCloseDialogOpen} onClose={handleJobCloseDialogClose} maxWidth="sm" fullWidth>
            <DialogTitle>Close Job</DialogTitle>
            <DialogContent>
              <div style={{ maxWidth: '600px', margin: '0 auto' }}>
                <div style={{ marginBottom: '16px', width: '100%' }}>
                  <FormLabel component="legend" style={{ marginBottom: '8px' }}>Finish Good</FormLabel>
                  <RadioGroup
                    row
                    value={finishGoodSelection}
                    onChange={(e) => setFinishGoodSelection(e.target.value)}
                  >
                    <FormControlLabel
                      value="yes"
                      control={<Radio />}
                      label="Yes"
                      disabled={finishedGood === 0}
                    />
                    <FormControlLabel
                      value="no"
                      control={<Radio />}
                      label="No"
                      disabled={finishedGood === 0}
                    />
                  </RadioGroup>
                </div>

                <div style={{ marginBottom: '16px', width: '100%' }}>
                  <FormLabel component="legend" style={{ marginBottom: '8px' }}>Job Status</FormLabel>
                  <RadioGroup
                    row
                    value={jobStatus}
                    onChange={(e) => setJobStatus(e.target.value)}
                  >
                    <FormControlLabel value="complete" control={<Radio />} label="Complete" />
                    <FormControlLabel value="incomplete" control={<Radio />} label="Incomplete" />
                  </RadioGroup>
                </div>

                <TextField
                  label="Production Quantity"
                  value={productionQty}
                  onChange={handleProductionQtyChange}
                  inputProps={{ inputMode: 'numeric', maxLength: 6, }}
                  fullWidth
                  margin="dense"
                  error={productionQtyError}
                  helperText={productionQtyError ? "Production quantity is required" : ""}
                  style={{ marginBottom: '16px' }}
                />

                <TextField
                  label="Waste Quantity"
                  value={wasteQty}
                  onChange={handleWasteQtyChange}
                  inputProps={{ inputMode: 'numeric', maxLength: 6, }}
                  fullWidth
                  margin="dense"
                  error={wasteQtyError}
                  helperText={wasteQtyError ? "Waste quantity is required" : ""}
                  style={{ marginBottom: '16px' }}
                />

                <TextField
                  label="Remarks"
                  value={remarks}
                  onChange={(e) => {
                    if (e.target.value.length <= 50) {
                      setRemarks(e.target.value);
                    }
                  }}
                  multiline
                  rows={2}
                  fullWidth
                  margin="dense"
                  helperText={`${remarks.length}/50`}
                  style={{ marginBottom: '16px' }}
                />
              </div>
            </DialogContent>
            <DialogActions>
              <Button onClick={handleConfirmEndJobClose} color="primary" variant="contained">
                Confirm and End
              </Button>
              <Button onClick={handleJobCloseDialogClose} color="secondary" variant="contained">
                Cancel
              </Button>
            </DialogActions>
          </Dialog>

          <Dialog
            open={jobCloseDialogOpen}
            onClose={handleJobCloseDialogClose}
            maxWidth="md"
            fullWidth
            PaperProps={{
              sx: {
                borderRadius: 2,
                boxShadow: '0 20px 25px -5px rgba(0, 0, 0, 0.1), 0 10px 10px -5px rgba(0, 0, 0, 0.04)',
                maxHeight: '90vh'
              }
            }}
          >
            {/* Header */}
            <DialogTitle sx={{ pb: 2 }}>
              <Box display="flex" alignItems="center" gap={2}>
                <Box
                  sx={{
                    width: 40,
                    height: 40,
                    bgcolor: 'primary.light',
                    borderRadius: '50%',
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center'
                  }}
                >
                  <AssignmentIcon sx={{ color: 'primary.main' }} />
                </Box>
                <Box>
                  <Typography variant="h6" component="h2" fontWeight={600}>
                    Close Job Assignment
                  </Typography>
                  <Typography variant="body2" color="text.secondary">
                    Complete job details and finalize
                  </Typography>
                </Box>
              </Box>
            </DialogTitle>

            {/* Content */}
            {/* <DialogContent sx={{ pt: 0, pb: 2 }}>
              <Box sx={{ maxWidth: '100%', margin: '0 auto' }}>




                <Paper
                  elevation={0}
                  sx={{
                    p: 2,
                    mb: 2,
                    bgcolor: 'grey.50',
                    border: '1px solid',
                    borderColor: 'grey.200',
                    borderRadius: 1
                  }}
                >
                  <Box display="flex" gap={3}>

                    <Box flex={1}>
                      <Box display="flex" alignItems="center" gap={1} mb={1}>
                        <CheckCircleIcon sx={{ fontSize: 20, color: 'success.main' }} />
                        <FormLabel component="legend" sx={{ fontWeight: 600, color: 'text.primary' }}>
                          Finish Good Status
                        </FormLabel>
                        {finishedGood === 0 && (
                          <Chip
                            label="Disabled"
                            size="small"
                            color="warning"
                            variant="outlined"
                          />
                        )}
                      </Box>
                      <RadioGroup
                        row
                        value={finishGoodSelection}
                        onChange={(e) => setFinishGoodSelection(e.target.value)}
                        sx={{ mt: 1 }}
                      >
                        <FormControlLabel
                          value="yes"
                          control={<Radio />}
                          label="Yes"
                          disabled={finishedGood === 0}
                          sx={{
                            '& .MuiFormControlLabel-label': {
                              fontSize: '0.95rem'
                            }
                          }}
                        />
                        <FormControlLabel
                          value="no"
                          control={<Radio />}
                          label="No"
                          disabled={finishedGood === 0}
                          sx={{
                            '& .MuiFormControlLabel-label': {
                              fontSize: '0.95rem'
                            }
                          }}
                        />
                      </RadioGroup>
                    </Box>


                    <Divider orientation="vertical" flexItem />


                    <Box flex={1}>
                      <Box display="flex" alignItems="center" gap={1} mb={1}>
                        <AssignmentIcon sx={{ fontSize: 20, color: 'primary.main' }} />
                        <FormLabel component="legend" sx={{ fontWeight: 600, color: 'text.primary' }}>
                          Job Status
                        </FormLabel>
                      </Box>
                      <RadioGroup
                        row
                        value={jobStatus}
                        onChange={(e) => setJobStatus(e.target.value)}
                        sx={{ mt: 1 }}
                      >
                        <FormControlLabel
                          value="complete"
                          control={<Radio />}
                          label="Complete"
                          sx={{
                            '& .MuiFormControlLabel-label': {
                              fontSize: '0.95rem'
                            }
                          }}
                        />
                        <FormControlLabel
                          value="incomplete"
                          control={<Radio />}
                          label="Incomplete"
                          sx={{
                            '& .MuiFormControlLabel-label': {
                              fontSize: '0.95rem'
                            }
                          }}
                        />
                      </RadioGroup>
                    </Box>
                  </Box>
                </Paper>

                <Divider sx={{ my: 2 }} />


                <Typography variant="h6" sx={{ mb: 2, fontWeight: 600, color: 'text.primary' }}>
                  Production Details
                </Typography>

                <Box display="flex" gap={2} mb={2}>
                  <TextField
                    label="Production Quantity"
                    value={productionQty}
                    onChange={handleProductionQtyChange}
                    inputProps={{ inputMode: 'numeric', maxLength: 7 }}
                    fullWidth
                    error={productionQtyError}
                    helperText={productionQtyError ? "Production quantity is required" : ""}
                    InputProps={{
                      startAdornment: (
                        <Box sx={{ mr: 1, display: 'flex', alignItems: 'center' }}>
                          <InventoryIcon sx={{ fontSize: 18, color: 'text.secondary' }} />
                        </Box>
                      )
                    }}
                  />

                  <TextField
                    label="Waste Quantity"
                    value={wasteQty}
                    onChange={handleWasteQtyChange}
                    inputProps={{ inputMode: 'numeric', maxLength: 6 }}
                    fullWidth
                    error={wasteQtyError}
                    helperText={wasteQtyError ? "Waste quantity is required" : ""}
                    InputProps={{
                      startAdornment: (
                        <Box sx={{ mr: 1, display: 'flex', alignItems: 'center' }}>
                          <WasteIcon sx={{ fontSize: 18, color: 'text.secondary' }} />
                        </Box>
                      )
                    }}
                  />
                </Box>


                <TextField
                  label="Remarks"
                  value={remarks}
                  onChange={(e) => {
                    if (e.target.value.length <= 50) {
                      setRemarks(e.target.value);
                    }
                  }}
                  multiline
                  rows={3}
                  fullWidth
                  helperText={`${remarks.length}/50 characters`}
                  placeholder="Add any additional notes or comments..."
                  InputProps={{
                    startAdornment: (
                      <Box sx={{ mr: 1, display: 'flex', alignItems: 'flex-start', pt: 1 }}>
                        <NotesIcon sx={{ fontSize: 18, color: 'text.secondary' }} />
                      </Box>
                    )
                  }}
                  sx={{ mb: 2 }}
                />


                <Paper
                  elevation={0}
                  sx={{
                    p: 2,
                    bgcolor: 'primary.light',
                    border: '1px solid',
                    borderColor: 'primary.main',
                    borderRadius: 1
                  }}
                >
                  <Typography variant="subtitle2" sx={{ fontWeight: 600, mb: 1 }}>
                    Job Summary
                  </Typography>
                  <Box display="flex" flexWrap="wrap" gap={1}>
                    <Chip
                      label={`Status: ${jobStatus || 'Not selected'}`}
                      size="small"
                      color={jobStatus === 'complete' ? 'success' : 'default'}
                    />
                    <Chip
                      label={`Production: ${productionQty || '0'}`}
                      size="small"
                      color="primary"
                    />
                    <Chip
                      label={`Waste: ${wasteQty || '0'}`}
                      size="small"
                      color="warning"
                    />
                    <Chip
                      label={`Finish Good: ${finishGoodSelection || 'Not selected'}`}
                      size="small"
                      color={finishGoodSelection === 'yes' ? 'success' : 'default'}
                    />
                  </Box>
                </Paper>
              </Box>
            </DialogContent> */}


            <DialogContent sx={{ pt: 0, pb: 2 }}>
              <Box sx={{ maxWidth: '100%', margin: '0 auto' }}>



                {/* Finish Good Status and Job Status - Combined in One Row */}
                <Paper
                  elevation={0}
                  sx={{
                    p: 2,
                    mb: 2,
                    bgcolor: 'grey.50',
                    border: '1px solid',
                    borderColor: 'grey.200',
                    borderRadius: 1
                  }}
                >
                  <Box display="flex" gap={3}>
                    {/* Finish Good Status - Left Side */}
                    <Box flex={1}>
                      <Box display="flex" alignItems="center" gap={1} mb={1}>
                        <CheckCircleIcon sx={{ fontSize: 20, color: 'success.main' }} />
                        <FormLabel component="legend" sx={{ fontWeight: 600, color: 'text.primary' }}>
                          Finish Good Status
                        </FormLabel>
                        {finishedGood === 0 && (
                          <Chip
                            label="Disabled"
                            size="small"
                            color="warning"
                            variant="outlined"
                          />
                        )}
                      </Box>
                      <RadioGroup
                        row
                        value={finishGoodSelection}
                        onChange={(e) => {
                          setFinishGoodSelection(e.target.value);
                          // Reset packing details when switching to "no"
                          if (e.target.value === 'no') {
                            setPackingDetails([{ id: 1, boxes: '', cartonsPerBox: '', total: 0 }]);
                            setPackingDetailsError(false);
                          }
                        }}
                        sx={{ mt: 1 }}
                      >
                        <FormControlLabel
                          value="yes"
                          control={<Radio />}
                          label="Yes"
                          disabled={finishedGood === 0}
                          sx={{
                            '& .MuiFormControlLabel-label': {
                              fontSize: '0.95rem'
                            }
                          }}
                        />
                        <FormControlLabel
                          value="no"
                          control={<Radio />}
                          label="No"
                          disabled={finishedGood === 0}
                          sx={{
                            '& .MuiFormControlLabel-label': {
                              fontSize: '0.95rem'
                            }
                          }}
                        />
                      </RadioGroup>
                    </Box>

                    {/* Divider */}
                    <Divider orientation="vertical" flexItem />

                    {/* Job Status - Right Side */}
                    <Box flex={1}>
                      <Box display="flex" alignItems="center" gap={1} mb={1}>
                        <AssignmentIcon sx={{ fontSize: 20, color: 'primary.main' }} />
                        <FormLabel component="legend" sx={{ fontWeight: 600, color: 'text.primary' }}>
                          Job Status
                        </FormLabel>
                      </Box>
                      <RadioGroup
                        row
                        value={jobStatus}
                        onChange={(e) => setJobStatus(e.target.value)}
                        sx={{ mt: 1 }}
                      >
                        <FormControlLabel
                          value="complete"
                          control={<Radio />}
                          label="Complete"
                          sx={{
                            '& .MuiFormControlLabel-label': {
                              fontSize: '0.95rem'
                            }
                          }}
                        />
                        <FormControlLabel
                          value="incomplete"
                          control={<Radio />}
                          label="Incomplete"
                          sx={{
                            '& .MuiFormControlLabel-label': {
                              fontSize: '0.95rem'
                            }
                          }}
                        />
                      </RadioGroup>
                    </Box>
                  </Box>
                </Paper>

                {/* Packing Details Section - Only show when Finish Good is "Yes" */}
                {/* Packing Details Section - Only show when Finish Good is "Yes" */}
                {finishGoodSelection === 'yes' && (
                  <Paper
                    elevation={0}
                    sx={{
                      p: 2,
                      mb: 2,
                      bgcolor: alpha(theme.palette.success.main, 0.05),
                      border: '1px solid',
                      borderColor: packingDetailsError ? 'error.main' : alpha(theme.palette.success.main, 0.2),
                      borderRadius: 1
                    }}
                  >
                    <Box display="flex" alignItems="center" justifyContent="space-between" mb={2}>
                      <Box display="flex" alignItems="center" gap={1}>
                        <InventoryIcon sx={{ fontSize: 20, color: 'success.main' }} />
                        <Typography variant="subtitle1" sx={{ fontWeight: 600, color: 'text.primary' }}>
                          Packing Details
                        </Typography>
                        <Chip
                          label={`Total: ${formatPackingNumber(getTotalCartons())} cartons`}
                          size="small"
                          color="success"
                          sx={{ fontWeight: 600 }}
                        />
                      </Box>
                      <Tooltip
                        title={
                          packingDetails.some(row => !row.boxes || !row.cartonsPerBox)
                            ? "Please complete the current row before adding a new one"
                            : "Add another packing entry"
                        }
                      >
                        <span>
                          <IconButton
                            onClick={handleAddPackingRow}
                            disabled={packingDetails.some(row => !row.boxes || !row.cartonsPerBox)}
                            size="small"
                            sx={{
                              backgroundColor: 'success.main',
                              color: 'white',

                              '&:disabled': {
                                backgroundColor: 'grey.300',
                                color: 'grey.500'
                              },
                              transition: 'all 0.2s'
                            }}
                          >
                            <AddIcon sx={{ fontSize: 18 }} />
                          </IconButton>
                        </span>
                      </Tooltip>
                    </Box>

                    {packingDetailsError && (
                      <Alert severity="error" sx={{ mb: 2 }}>
                        Please complete all packing details or remove empty rows.
                      </Alert>
                    )}

                    {/* Rest of the packing details rows remain the same... */}

                    {/* Packing Details Rows */}
                    <Box sx={{ display: 'flex', flexDirection: 'column', gap: 1.5 }}>
                      {packingDetails.map((row, index) => (
                        <Paper
                          key={row.id}
                          elevation={1}
                          sx={{
                            p: 2,
                            backgroundColor: 'white',
                            border: '1px solid',
                            borderColor: 'grey.200',
                            borderRadius: 1,
                            transition: 'all 0.2s',

                          }}
                        >
                          <Box display="flex" gap={2} alignItems="center">
                            {/* Row Number */}
                            <Chip
                              label={`#${index + 1}`}
                              size="small"
                              sx={{
                                minWidth: 40,
                                fontWeight: 600,
                                backgroundColor: 'success.light',
                                color: 'success.contrastText'
                              }}
                            />

                            {/* Number of Boxes */}
                            <TextField
                              label="Number of Boxes"
                              value={formatPackingNumber(row.boxes)}
                              onChange={(e) => handlePackingChange(row.id, 'boxes', e.target.value)}
                              inputProps={{ inputMode: 'numeric', maxLength: 6 }}
                              size="small"
                              sx={{ flex: 1 }}
                              error={packingDetailsError && !row.boxes}
                              helperText={packingDetailsError && !row.boxes ? "Required" : ""}
                            />

                            {/* Multiply Icon */}
                            <Typography variant="h6" sx={{ color: 'text.secondary', px: 1 }}>
                              ×
                            </Typography>

                            {/* Cartons per Box */}
                            <TextField
                              label="Cartons per Box"
                              value={formatPackingNumber(row.cartonsPerBox)}
                              onChange={(e) => handlePackingChange(row.id, 'cartonsPerBox', e.target.value)}
                              inputProps={{ inputMode: 'numeric', maxLength: 6 }}
                              size="small"
                              sx={{ flex: 1 }}
                              error={packingDetailsError && !row.cartonsPerBox}
                              helperText={packingDetailsError && !row.cartonsPerBox ? "Required" : ""}
                            />

                            {/* Equals Icon */}
                            <Typography variant="h6" sx={{ color: 'text.secondary', px: 1 }}>
                              =
                            </Typography>

                            {/* Total */}
                            <TextField
                              label="Total Cartons"
                              value={formatPackingNumber(row.total)}
                              size="small"
                              sx={{
                                flex: 1,
                                '& .MuiInputBase-input': {
                                  fontWeight: 600,
                                  color: 'success.main'
                                }
                              }}
                              InputProps={{
                                readOnly: true,
                              }}
                            />

                            {/* Remove Button */}
                            <Tooltip title="Remove this row">
                              <span>
                                <IconButton
                                  onClick={() => handleRemovePackingRow(row.id)}
                                  disabled={packingDetails.length === 1}
                                  size="small"
                                  sx={{
                                    color: 'error.main',

                                    '&:disabled': {
                                      color: 'grey.400'
                                    },
                                    transition: 'all 0.2s'
                                  }}
                                >
                                  <RemoveIcon sx={{ fontSize: 18 }} />
                                </IconButton>
                              </span>
                            </Tooltip>
                          </Box>
                        </Paper>
                      ))}
                    </Box>

                    {/* Summary */}
                    {packingDetails.length > 1 && (
                      <Box
                        sx={{
                          mt: 2,
                          p: 1.5,
                          backgroundColor: alpha(theme.palette.success.main, 0.1),
                          borderRadius: 1,
                          display: 'flex',
                          justifyContent: 'space-between',
                          alignItems: 'center'
                        }}
                      >
                        <Typography variant="body2" sx={{ fontWeight: 600 }}>
                          Total Entries: {packingDetails.length}
                        </Typography>
                        <Typography variant="body1" sx={{ fontWeight: 700, color: 'success.main' }}>
                          Grand Total: {formatPackingNumber(getTotalCartons())} Cartons
                        </Typography>
                      </Box>
                    )}
                  </Paper>
                )}

                <Divider sx={{ my: 2 }} />

                {/* Rest of the content remains the same... */}
                {/* Quantity Section */}
                <Typography variant="h6" sx={{ mb: 2, fontWeight: 600, color: 'text.primary' }}>
                  Production Details
                </Typography>

                <Box display="flex" gap={2} mb={2}>
                  <TextField
                    label="Production Quantity"
                    value={productionQty}
                    onChange={handleProductionQtyChange}
                    inputProps={{ inputMode: 'numeric', maxLength: 7 }}
                    fullWidth
                    error={productionQtyError}
                    helperText={productionQtyError ? "Production quantity is required" : ""}
                    InputProps={{
                      startAdornment: (
                        <Box sx={{ mr: 1, display: 'flex', alignItems: 'center' }}>
                          <InventoryIcon sx={{ fontSize: 18, color: 'text.secondary' }} />
                        </Box>
                      )
                    }}
                  />

                  <TextField
                    label="Waste Quantity"
                    value={wasteQty}
                    onChange={handleWasteQtyChange}
                    inputProps={{ inputMode: 'numeric', maxLength: 6 }}
                    fullWidth
                    error={wasteQtyError}
                    helperText={wasteQtyError ? "Waste quantity is required" : ""}
                    InputProps={{
                      startAdornment: (
                        <Box sx={{ mr: 1, display: 'flex', alignItems: 'center' }}>
                          <WasteIcon sx={{ fontSize: 18, color: 'text.secondary' }} />
                        </Box>
                      )
                    }}
                  />
                </Box>

                {/* Remarks Section */}
                <TextField
                  label="Remarks"
                  value={remarks}
                  onChange={(e) => {
                    if (e.target.value.length <= 50) {
                      setRemarks(e.target.value);
                    }
                  }}
                  multiline
                  rows={3}
                  fullWidth
                  helperText={`${remarks.length}/50 characters`}
                  placeholder="Add any additional notes or comments..."
                  InputProps={{
                    startAdornment: (
                      <Box sx={{ mr: 1, display: 'flex', alignItems: 'flex-start', pt: 1 }}>
                        <NotesIcon sx={{ fontSize: 18, color: 'text.secondary' }} />
                      </Box>
                    )
                  }}
                  sx={{ mb: 2 }}
                />

                {/* Summary Section */}
                <Paper
                  elevation={0}
                  sx={{
                    p: 2,
                    bgcolor: 'primary.light',
                    border: '1px solid',
                    borderColor: 'primary.main',
                    borderRadius: 1
                  }}
                >
                  <Typography variant="subtitle2" sx={{ fontWeight: 600, mb: 1 }}>
                    Job Summary
                  </Typography>
                  <Box display="flex" flexWrap="wrap" gap={1}>
                    <Chip
                      label={`Status: ${jobStatus || 'Not selected'}`}
                      size="small"
                      color={jobStatus === 'complete' ? 'success' : 'default'}
                    />
                    <Chip
                      label={`Production: ${productionQty || '0'}`}
                      size="small"
                      color="primary"
                    />
                    <Chip
                      label={`Waste: ${wasteQty || '0'}`}
                      size="small"
                      color="warning"
                    />
                    <Chip
                      label={`Finish Good: ${finishGoodSelection || 'Not selected'}`}
                      size="small"
                      color={finishGoodSelection === 'yes' ? 'success' : 'default'}
                    />
                    {finishGoodSelection === 'yes' && getTotalCartons() > 0 && (
                      <Chip
                        label={`Total Cartons: ${formatPackingNumber(getTotalCartons())}`}
                        size="small"
                        color="success"
                        sx={{ fontWeight: 600 }}
                      />
                    )}
                  </Box>
                </Paper>
              </Box>
            </DialogContent>

            {/* Actions */}
            <DialogActions sx={{ px: 3, pb: 3, gap: 1, justifyContent: 'center' }}>
              <Button
                onClick={handleJobCloseDialogClose}
                variant="outlined"
                color="inherit"
                startIcon={<CancelIcon />}
                sx={{
                  minWidth: 120,
                  textTransform: 'none',
                  fontWeight: 500
                }}
              >
                Cancel
              </Button>
              <Button
                onClick={handleConfirmEndJobClose}
                variant="contained"
                color="primary"
                startIcon={<CheckCircleIcon />}
                sx={{
                  minWidth: 150,
                  textTransform: 'none',
                  fontWeight: 500
                }}
              >
                Confirm & Close
              </Button>
            </DialogActions>
          </Dialog>


          <Dialog
            open={bulkActionDialogOpen}
            onClose={() => setBulkActionDialogOpen(false)}
            maxWidth="sm"
            fullWidth
            PaperProps={{
              sx: {
                borderRadius: 2,
                boxShadow: '0 20px 25px -5px rgba(0, 0, 0, 0.1), 0 10px 10px -5px rgba(0, 0, 0, 0.04)'
              }
            }}
          >
            {/* Header */}
            <DialogTitle sx={{ pb: 2 }}>
              <Box display="flex" alignItems="center" gap={2}>
                <Box
                  sx={{
                    width: 40,
                    height: 40,
                    bgcolor: bulkActionType === 'idle' ? 'warning.light' : 'error.light',
                    borderRadius: '50%',
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center'
                  }}
                >
                  {bulkActionType === 'idle' ? (
                    <ScheduleIcon sx={{ color: 'warning.main' }} />
                  ) : (
                    <PersonRemoveIcon sx={{ color: 'error.main' }} />
                  )}
                </Box>
                <Box>
                  <Typography variant="h6" component="h2" fontWeight={600}>
                    {bulkActionType === 'idle' ? 'Assign Idle Time' : 'Remove Employees'}
                  </Typography>
                  <Typography variant="body2" color="text.secondary">
                    Bulk action confirmation
                  </Typography>
                </Box>
              </Box>
            </DialogTitle>

            {/* Content */}
            <DialogContent sx={{ pt: 0, pb: 2 }}>
              {/* Action Summary */}
              <Box
                sx={{
                  display: 'flex',
                  alignItems: 'center',
                  gap: 2,
                  p: 2,
                  bgcolor: 'grey.50',
                  borderRadius: 1,
                  border: '1px solid',
                  borderColor: 'grey.200',
                  mb: 2
                }}
              >
                <GroupIcon sx={{ color: 'text.secondary' }} />
                <Box flex={1}>
                  <Typography variant="body1" fontWeight={500}>
                    {bulkActionType === 'idle' ? 'Idle Time Assignment' : 'Employee Removal'}
                  </Typography>
                  <Box display="flex" alignItems="center" gap={1} mt={0.5}>
                    <Typography variant="body2" color="text.secondary">
                      Selected employees:
                    </Typography>
                    <Chip
                      label={`${selectedEmployees.size} employee${selectedEmployees.size > 1 ? 's' : ''}`}
                      size="small"
                      color="primary"
                      variant="outlined"
                    />
                  </Box>
                </Box>
              </Box>

              {/* Warning/Info Message */}
              <Alert
                severity={bulkActionType === 'idle' ? 'info' : 'warning'}
                icon={bulkActionType === 'idle' ? <ScheduleIcon /> : <WarningIcon />}
                sx={{
                  mb: 2,
                  '& .MuiAlert-message': {
                    fontSize: '0.95rem'
                  }
                }}
              >
                {bulkActionType === 'idle'
                  ? 'This will assign idle time to all selected employees and suspend their active assignments.'
                  : 'This will remove all selected employees from their current workstations. They can be reassigned later if needed.'
                }
              </Alert>

              <Divider sx={{ my: 2 }} />

              {/* Confirmation Question */}
              <Box sx={{ textAlign: 'center' }}>
                <Typography variant="body1" color="text.primary" fontWeight={500}>
                  Are you sure you want to {bulkActionType === 'idle' ? 'assign idle time to' : 'remove'} these {selectedEmployees.size} employee{selectedEmployees.size > 1 ? 's' : ''}?
                </Typography>
              </Box>
            </DialogContent>

            {/* Actions */}
            <DialogActions sx={{ px: 3, pb: 3, gap: 1, justifyContent: 'center' }}>
              <Button
                onClick={() => setBulkActionDialogOpen(false)}
                variant="outlined"
                color="inherit"
                startIcon={<CloseIcon />}
                sx={{
                  minWidth: 100,
                  textTransform: 'none',
                  fontWeight: 500
                }}
              >
                Cancel
              </Button>
              <Button
                onClick={confirmBulkAction}
                variant="contained"
                color={bulkActionType === 'idle' ? 'warning' : 'error'}
                startIcon={<CheckIcon />}
                sx={{
                  minWidth: 120,
                  textTransform: 'none',
                  fontWeight: 500
                }}
              >
                {bulkActionType === 'idle' ? 'Assign Idle' : 'Remove All'}
              </Button>
            </DialogActions>
          </Dialog>
        </>
      )}

      <Snackbar
        open={snackbarOpen}
        autoHideDuration={3000}
        onClose={handleSnackbarClose}
        anchorOrigin={{ vertical: 'bottom', horizontal: 'center' }}
      >
        <Alert variant="filled" onClose={handleSnackbarClose} severity={snackbarSeverity}>
          {snackbarMessage}
        </Alert>
      </Snackbar>
    </>
  );
};

SupervisorEnterDashbord.propTypes = {
  supervisorId: PropTypes.any.isRequired,
  machineCode: PropTypes.string.isRequired,
  Groupcode: PropTypes.string.isRequired,
  finishedGood: PropTypes.string.isRequired,
  refreshKey: PropTypes.number,
  onTriggerSnackbar: PropTypes.func.isRequired,
};

export default SupervisorEnterDashbord;